import { ChangeDetectorRef, Injectable, OnDestroy } from "@angular/core";
import { Customer, CustomerDetailInfoViewModel } from "../parties/model/customer.model";
import { Personnel } from "../parties/model/personnel.model";
import { OrderItem, OrderItemCategory } from "./model/orderItemcategory.model";
import { Branch, Lookup, User } from "projects/sepidz-web-framework/src/lib/models";
import { SaleMethodBranchModel, SaleMethodNature } from "../sales/model/sale-method-branch.model";
import { DiscountTypeEnum, Invoice, InvoiceCommand, InvoiceItem, InvoiceStatus, ItemStateEnum, LastInvoiceInformation } from "./model/invoice.model";
import { AccountService, GridFilter, LocalStoreManager } from "projects/sepidz-web-framework/src/lib/services";
import { OrderSettingModel } from "./model/ordersetting.model";
import { FormControl, FormGroup, UntypedFormControl, Validators } from "@angular/forms";
import { ActivePageEnum } from "./model/activepage.enum";
import { FastAccessEnum } from "./model/fastaccessenum";
import { CommonService } from "projects/sepidz-web-framework/src/lib/services/common.service";
import { delay, take, takeUntil, tap } from "rxjs/operators";
import { SplashScreenService } from "projects/sepidz-web-framework-shell/src/lib/shared/splash-form/SplashScreenService";
import { SplashFormService } from "projects/sepidz-web-framework-shell/src/lib/shared/splash-form/Splash-form.service";
import { Salon } from "../salons/model/salon.model";
import { PaymentMethodLookUp } from "./model/payment.lookup";
import { DialogType } from "../../../../projects/sepidz-web-framework/src/lib/models/dialog.enum";
import { SalePriceType } from "../catalog/model/sale-price-type.model";
import { BaseService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-service.component";
import { RowState } from "../../../../projects/sepidz-web-framework/src/lib/models/enums";
import { ItemDependencyType } from "./model/ItemOrder.model";
import { ActionStateModel } from "./model/actionstate.model";
import { TabularService } from "../../../../projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { PrintPolicy } from "../prints/model/print-policy.model";
import { PrintTemplate } from "../prints/model/print-template.model";
import { ClearableCache } from "projects/sepidz-web-framework/src/lib/models/clearablecache.model";
import { ChangeCachEnum } from "./model/changecach.enum";
import { BarCodeReaderFormat } from "src/app/gnr/bar-code-reader-format/bar-code-reader-format.model";
import { PrinterQueue } from "./model/printerqueue.model";
import { DepositModel, DepositPersonnelModel } from "../catalog/model/deposit.model";
import { DepositFormSettingModel } from "./orderpage/item/deposit/depositformsetting.model";
import { SaleMethodBranchItemEnum } from "./model/salemethodbranchitem.enum";
import { InvDailyWarehouse } from "../inv/model/inv-daily-warehouse.model";
import { CategoryPopupState, ItemBranch, StockInWebKind } from "../catalog/model/item.model";
import * as moment from "moment";
import { IndexedDbService } from "projects/sepidz-web-framework/src/lib/services/indexed-db.service";
import { FavoriteItem } from "./model/favoriteitem.model";
import { PosScaleService } from "./providers/pos-scale.service";
import { CustomerCategory } from "../parties/model/customer-categories.model";

@Injectable({
  providedIn: "root",
})
export class OrderService extends BaseService implements OnDestroy {
  canSeeFavorites: boolean = false;
  public saleMethodBranch: SaleMethodBranchModel = new SaleMethodBranchModel();
  public changeSaleMethodBranch: SaleMethodBranchModel = new SaleMethodBranchModel();
  public invoiceChanged: boolean;
  public saleMethodBranchChanged: boolean = false;
  public PrintPolicy: PrintPolicy[];
  public PrintTemplate: PrintTemplate[];
  public itemChanged: boolean = false;
  public salePricePermission: boolean = false;
  public salons: Salon[] = [];
  salePriceType: SalePriceType[] = [];
  salePriceTypesAll: SalePriceType[] = [];
  public itemHasParent: OrderItem[];
  public customer: Customer;
  public DefultCustomer: Customer;
  public invoice: Invoice = new Invoice();
  public oldinvoice: Invoice;
  public waiters: Personnel[];
  public currentBranch: Branch;
  public Branches: Branch[] = [];
  public currentUser: User = JSON.parse(localStorage.getItem("current_User_Info"));
  public itemCategoryList: OrderItemCategory[];
  public itemCategoryListAll: OrderItemCategory[];
  public selectedItemCategory: OrderItemCategory = new OrderItemCategory();
  public hideFastAccess: boolean;
  public selectedOrderItem: OrderItem = new OrderItem();
  public selectedOrderItemIndex: number;
  public selectedInvoiceItem: InvoiceItem = new InvoiceItem();
  public oldSaleMethodBranchId: number;
  public OrderSetting: OrderSettingModel = new OrderSettingModel();
  public saleMethodList: SaleMethodBranchModel[];
  public currentsaleMethodList: SaleMethodBranchModel[];
  public currentActivePage: ActivePageEnum;
  public defaultCustomerId: number;
  public DelinoInvoiceCount: number;
  public showHeader: boolean;
  customerFormIsShowBefore: boolean;
  /// برای باز و بسته شدن ساید منو
  _opened: boolean = false;
  selectedFastAccess: FastAccessEnum;
  // پرشدن نام گارسون در موبایل
  public waiterMobile: string;
  public waiterId: number;
  public SaleMethodBranchId: number;
  // تب جاری
  activePageEnum: typeof ActivePageEnum = ActivePageEnum;
  SaleMethodNature: typeof SaleMethodNature = SaleMethodNature;
  InvoiceStatus: typeof InvoiceStatus = InvoiceStatus;
  public currentSaleMethodNature: number;
  public cd: ChangeDetectorRef;
  public cd_Invoice: ChangeDetectorRef;
  public cd_Description: ChangeDetectorRef;
  public cd_DescKitchen: ChangeDetectorRef;
  public cd_DescCustomer: ChangeDetectorRef;
  public cd_Total: ChangeDetectorRef;
  public cd_Salons: ChangeDetectorRef;
  public cd_FastAccess: ChangeDetectorRef;
  public cd_FastAccessClub: ChangeDetectorRef;
  public cd_FastAccessCustomer: ChangeDetectorRef;
  public cd_FastAccessDriverAssignment: ChangeDetectorRef;
  public cd_FastAccessInvoiceChange: ChangeDetectorRef;
  public cd_FastAccessPager: ChangeDetectorRef;
  public cd_FastAccessSalon: ChangeDetectorRef;
  public cd_FastAccessWaiter: ChangeDetectorRef;
  public cd_Header: ChangeDetectorRef;
  public cd_Footer: ChangeDetectorRef;
  public cd_Item: ChangeDetectorRef;
  public cd_Deposit: ChangeDetectorRef;
  public invoiceStatusLookups: Lookup[];
  public invoiceChangesLookups: Lookup[] = [];
  public invoiceCommandLookups: Lookup[] = [];
  public invoicePayableChangeLookups: Lookup[] = [];
  public receiptPaymentTypeLookup: Lookup[] = [];
  public PhoneTypeLookup: Lookup[] = [];
  public paymentMethodTypeLookup: PaymentMethodLookUp[] = [];
  public CustomDescriptionId?: number;
  public actionState: ActionStateModel = new ActionStateModel();
  public tabsservice: TabularService;
  public CallCenterLookUp: Lookup[] = [];
  public RestaurantCallCenter: boolean = false;
  changeCachEnum: ChangeCachEnum[] = [];
  public barCodeReaderFormat: BarCodeReaderFormat[] = JSON.parse(localStorage.getItem("BarCodeReaderFormat"));
  public __id: string;
  public inputBarCode: string;
  public defaultMinutesToDelivery: number;
  public defaultBranch: Branch;
  public printerQueue: PrinterQueue[] = [];
  public shouldActivateInvoicesPage = false;
  public shouldActivateReserveOnlinePage = false;
  public shouldActivateSalonPage = false;
  public freeShippingCostDiscount: number;
  public shouldCalculateFreeShippingCost = true;
  public otherCustomerPrintAccess: boolean = false;
  public lastInvoiceInformation: LastInvoiceInformation = new LastInvoiceInformation();
  isShowDeposit: boolean = false;
  public depositFormGroup: FormGroup = new FormGroup({
    InvoiceId: new FormControl(null),
    ServingFoodDate: new FormControl(null, [Validators.required]),
    ServingFoodTime: new FormControl(null, [Validators.required]),
    MealTime: new FormControl(null, [Validators.required]),
    DeliveryType: new FormControl(null, [Validators.required]),
    ClearType: new FormControl(null, [Validators.required]),
    NumberOfPeople: new FormControl(null),
    FoodPricePerson: new FormControl(null),
    NumberOfCooks: new FormControl(null),
    DepositPersonnelList: new FormControl(null),
    Id: new FormControl(0),
    Invoice: new FormControl(null),
    DepositAmount: new FormControl(null),
    ServicesAmount: new FormControl(0),
    RowVersion: new FormControl(),
    CreatedDate: new FormControl(),
  });
  public depositPersonnelList: DepositPersonnelModel[] = [];
  public depositServiceAmount = 0;
  public depositServiceAmountSummary: string;
  public depositServiceRemainSummary: string;
  public FoodPricePerson = true;
  public HasClearType = true;
  public HasDeliveryType = true;
  public HasNumberOfPeople = true;
  public HasNumberOfCooks = true;
  public HasServicesAmount = true;
  public HasDepositAmount = true;
  public originalDeposit: DepositModel;
  public depositListGridFilter: GridFilter[];
  public shouldCloseSidebar = true;
  warehouseStockItems: InvDailyWarehouse[] = [];
  dailyInventoryList: InvDailyWarehouse[] = [];
  stockDialogIsOpened: boolean;
  showChangeFactor: boolean = false;
  isLight = false;

  currentInformation = this.accountService.authService.currentInformation();
  logInBranch = this.accountService.authService.currentBranch;
  lastInformationIsLoading: boolean;
  defaultPaymentToSaving: boolean;
  orderOnlinePage: boolean = false;
  depositServiceRemain: number;
  autoDelinoInvoiceId: number;
  public itemQuantityChanged: boolean = false;
  validHappyHour: boolean = false;
  happyHourDiscountPrice: number;
  validFreeShipping: boolean = false;
  validFreeService: boolean = false;
  hasPosScale: boolean = false;
  shouldCalculate: boolean = true;
  DiscountOrganization = 0;
  WebKinds: Lookup[];

  constructor(
    public splashScreenService: SplashScreenService,
    public splashFormService: SplashFormService,
    public accountService: AccountService,
    public storage: LocalStoreManager,
    public common: CommonService,
    public indexedDbService: IndexedDbService,
    public posScaleService: PosScaleService
  ) {
    super();
    if (this.saleMethodBranch.Id) this.formGroupControl();
  }

  checkPermissions() {
    if (this.HasAccess("ChangeInvoiceSaleMethodBranch")) this.showChangeFactor = true;
    this.salePricePermission = this.HasAccess("UseSalePriceTypeOtherThanDefault");
  }

  formGroupControl() {
    this.setValue("Discount", undefined, false, Validators.maxLength(10));
    this.setValue("TotalService", undefined, false, Validators.maxLength(10));
    this.setValue("ShippingCost", undefined, false, Validators.maxLength(10));
    this.setValue("Debit", undefined, false, Validators.maxLength(10));
    this.setValue("Credit", undefined, false, Validators.maxLength(10));
    this.setValue("Description", undefined, false, Validators.maxLength(500));
    this.setValue("DescKitchen", undefined, false, Validators.maxLength(250));
    this.setValue("DescCustomer", undefined, false, Validators.maxLength(250));
    this.setValue("NumberOfGuests", undefined, false, Validators.maxLength(10));
    this.setValue("PackingPrice", undefined, false, Validators.maxLength(10));
    this.setValue("BranchId", undefined, false, Validators.maxLength(100));
    this.setValue("SalePriceTypeId", undefined, false, Validators.maxLength(10));
    if (!this.isMultiBranch) {
      this.setValue(`CustomDescription${this.invoice.SaleMethodBranchId}`, undefined, false, Validators.maxLength(200));
    }
    this.setApplySnapValue();
    if (this.currentSaleMethodNature === this.SaleMethodNature.FastFood) {
      this.setValue("InPerson", !!this.saleMethodBranch?.InPerson);
      this.invoice.InPerson = !!this.saleMethodBranch?.InPerson;
    }
    this.setValueQuantity();
  }
  setValueQuantity() {
    if (this.invoice?.Items?.length > 0) {
      this.invoice.Items.forEach((f) => {
        this.setValue(`itemsQuantity${f.Index}${this.invoice.SaleMethodBranchId}`, f.Quantity);
        if (this.oldSaleMethodBranchId !== this.invoice.SaleMethodBranchId)
          this.formGroup.removeControl(`itemsQuantity${f.Index}${this.oldSaleMethodBranchId}`);
      });
      this.detectChanges();
    }
  }
  controlsVisibility() {
    if (!this.currentInformation?.OrderServices) return;

    if (!this.storage.getData(ClearableCache.FormSetting)) {
      this.httpCommonService
        .getList("DepositFormSetting")
        .pipe(take(1))
        .subscribe((result: any[]) => {
          if (result?.length > 0) {
            this.storage.savePermanentData(result[0], ClearableCache.FormSetting);
            this.FoodPricePerson = result[0].FoodPricePerson ?? true;
            this.HasClearType = result[0].HasClearType ?? true;
            this.HasDeliveryType = result[0].HasDeliveryType ?? true;
            this.HasNumberOfCooks = result[0].HasNumberOfCooks ?? true;
            this.HasNumberOfPeople = result[0].HasNumberOfPeople ?? true;
            this.HasDepositAmount = result[0].HasDepositAmount ?? true;
            this.HasServicesAmount = result[0].HasServicesAmount ?? true;
          } else this.storage.savePermanentData(new DepositFormSettingModel(), ClearableCache.FormSetting);
        });
    } else {
      this.FoodPricePerson = this.storage.getData(ClearableCache.FormSetting)["FoodPricePerson"] ?? true;
      this.HasClearType = this.storage.getData(ClearableCache.FormSetting)["HasClearType"] ?? true;
      this.HasDeliveryType = this.storage.getData(ClearableCache.FormSetting)["HasDeliveryType"] ?? true;
      this.HasNumberOfCooks = this.storage.getData(ClearableCache.FormSetting)["HasNumberOfCooks"] ?? true;
      this.HasNumberOfPeople = this.storage.getData(ClearableCache.FormSetting)["HasNumberOfPeople"] ?? true;
      this.HasDepositAmount = this.storage.getData(ClearableCache.FormSetting)["HasDepositAmount"] ?? true;
      this.HasServicesAmount = this.storage.getData(ClearableCache.FormSetting)["HasServicesAmount"] ?? true;
    }
  }
  setValueformGroupControl() {
    this.setValue("Description", this.invoice.Description, false, Validators.maxLength(500));
    this.setValue("DescKitchen", this.invoice.DescKitchen, false, Validators.maxLength(250));
    this.setValue("DescCustomer", this.invoice.DescCustomer, false, Validators.maxLength(250));
    this.setValue("Discount", this.invoice.Discount);
    this.setValue("DiscountType", this.invoice.DiscountType);
    this.setValue("TotalService", this.invoice.TotalService);
    this.setValue("ShippingCost", this.invoice.ShippingCost);
    this.setValue("Debit", this.invoice.Debit);
    this.setValue("Credit", this.invoice.Credit);
    this.setValue("SalePriceTypeId", this.invoice.SalePriceTypeId);
    this.setValue("NumberOfGuests", this.invoice.NumberOfGuests);
    this.setValue("PackingPrice", this.invoice.PackingPrice);
    this.setApplySnapValue();
    if (this.currentSaleMethodNature === this.SaleMethodNature.FastFood) {
      this.setValue("InPerson", !!this.saleMethodBranch?.InPerson);
      this.invoice.InPerson = !!this.saleMethodBranch?.InPerson;
    }
    this.invoice.Items.forEach((f) => {
      if (!this.formGroup.controls[`RowDiscount${f.Index}${this.invoice.SaleMethodBranchId}`]) {
        this.formGroup.addControl(`RowDiscount${f.Index}${this.invoice.SaleMethodBranchId}`, new UntypedFormControl(f.RowDiscount));
        this.setValue(`RowDiscount${f.Index}${this.invoice.SaleMethodBranchId}`, f.RowDiscount);
      } else {
        this.setValue(`RowDiscount${f.Index}${this.invoice.SaleMethodBranchId}`, f.RowDiscount);
      }
    });
    if (this.common.isMobileMode) {
      this.invoice.Items.forEach((ele: InvoiceItem) => {
        this.itemCategoryList.forEach((element) => {
          element.Items.forEach((item) => {
            if (item.Id === ele?.ItemId || this.invoice.StatusCode === ItemStateEnum.Clear) {
              item.InvoiceQty =
                this.invoice.StatusCode === ItemStateEnum.Increase || this.invoice.StatusCode === ItemStateEnum.Decrease ? ele.Quantity : 0;
              this.setValueQuantity();
            } else {
              if (item.ItemChild && item.ItemChild.length > 0) {
                const find = item.ItemChild.find((f) => f.Id === ele?.CategoryId);
                const findchild = find?.ItemChild?.find((f) => f.Id === ele?.ItemId && f.BranchId === ele?.BranchId);
                if (findchild) {
                  item.InvoiceQty =
                    ele && (this.invoice.StatusCode === ItemStateEnum.Increase || this.invoice.StatusCode === ItemStateEnum.Decrease)
                      ? ele.Quantity
                      : 0;
                  this.setValueQuantity();
                }
              }
            }
          });
        });
      });
    }
  }

  newInvoice(withSetActivePage = true) {
    this.customerFormIsShowBefore = false;
    this.actionState.save = false;
    this.actionState.cancel = false;
    this.actionState.clear = false;
    this.actionState.clearWithoutPrint = false;
    this.actionState.mixClear = false;
    this.actionState.print = false;
    this.actionState.preparationPrint = false;
    this.actionState.temporaryRegister = false;
    this.actionState.customerPrint = false;
    this.itemHasParent = null;
    this.OrderSetting.showComplate = true;
    this.itemCategoryList?.forEach((element) => {
      element?.Items?.forEach((item) => {
        item.InvoiceQty = 0;
        item.ItemChild?.forEach((child) => {
          child.InvoiceQty = 0;
        });
      });
    });
    if (this.common.isMobileMode) this.OrderSetting.IsShowDescriptionBox = false;
    this.depositFormGroup.setValue(new DepositModel());
    this.depositPersonnelList = [];
    this.depositServiceAmountSummary = "";
    this.depositServiceAmount = 0;
    this.isShowDeposit = false;
    this.originalDeposit = null;
    this.detectChanges();
    this.oldinvoice = JSON.parse(JSON.stringify(this.invoice));
    this.invoice = null;
    this.invoice = new Invoice();
    this.invoice.LastInvoiceAmount = this.oldinvoice.LastInvoiceAmount;
    this.invoice.LastInvoiceCode = this.oldinvoice.LastInvoiceCode;
    this.selectedInvoiceItem = null;
    this.selectedOrderItemIndex = null;
    this.selectedOrderItem = null;
    this.selectedOrderItem = new OrderItem();
    this.invoiceChanged = false;
    this.itemChanged = false;
    this.invoice.SaleMethodBranchId = this.saleMethodBranch.Id;
    this.invoice.CustomerId = this.defaultCustomerId;
    this.invoice.CustomerNumber = this.DefultCustomer?.Party?.Number;
    this.invoice.CustomerLastName = this.DefultCustomer?.Party?.LastName;
    this.invoice.CustomerDisplayName = this.DefultCustomer?.Party?.DisplayName;
    this.invoice.AddressId = this.DefultCustomer?.Addresses[0]?.Id;
    this.invoice.CustomerAddress = this.DefultCustomer?.Addresses?.find((f) => f.IsDefault);
    this.invoice.PhoneId = this.DefultCustomer?.Numbers.length > 0 ? this.DefultCustomer?.Numbers[0]?.Id : null;
    this.invoice.PhoneNumber = this.DefultCustomer?.Numbers?.find((n) => n.IsDefault)?.Number;
    this.invoice.Customer = this.DefultCustomer;
    if (this.waiterMobile) {
      this.invoice.WaiterName = this.waiterMobile;
      this.invoice.WaiterId = this.waiterId;
    }
    this.indexedDbService.get("FrontOffice", "Categories").then((res) => {
      this.itemCategoryListAll = res;
      this.getItemCategory();
    });
    if (this.accountService.authService.currentFiscalYear) this.invoice.FiscalYearId = this.accountService.authService.currentFiscalYear.Id;
    else
      this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
        if (x) this.invoice.FiscalYearId = x.Id;
      });
    /// برگرداندن متد اصلی
    this.saleMethodBranch = JSON.parse(JSON.stringify(this.changeSaleMethodBranch));
    this.invoice.SaleMethodBranch = JSON.parse(JSON.stringify(this.changeSaleMethodBranch));
    this.invoice.SaleMethodBranchId = JSON.parse(JSON.stringify(this.changeSaleMethodBranch.Id));
    this.currentSaleMethodNature = this.changeSaleMethodBranch.SaleMethodNatureCode;
    this.currentsaleMethodList = this.saleMethodList?.filter((f) => f.Id !== this.saleMethodBranch.Id);
    this.invoice.SalePriceTypeId = this.oldinvoice.SalePriceTypeId;
    this.setValue("Discount", this.invoice.Discount);
    this.setValue("Description", "", false, Validators.maxLength(500));
    this.setValue("DescKitchen", "", false, Validators.maxLength(250));
    this.setValue("DescCustomer", "", false, Validators.maxLength(250));
    this.setValue(`Quantity${this.__id}`, "");
    this.setValue(`ItemTitle${this.__id}`, "");
    this.setValue(`Code${this.__id}`, "");
    this.setValue("TotalService", "");
    this.setValue("Debit", "");
    this.setValue("NumberOfGuests", "");
    this.setValue("PackingPrice", "");
    this.setValue("ShippingCost", "");
    this.setValue("BranchId", null);
    this.setValue("WebId", null);
    this.setValue("WebKindId", null);
    this.setApplySnapValue();
    if (this.currentSaleMethodNature === this.SaleMethodNature.FastFood) {
      this.setValue("InPerson", !!this.saleMethodBranch?.InPerson);
      this.invoice.InPerson = !!this.saleMethodBranch?.InPerson;
    }
    this.invoice.BranchId = null;
    this.invoice.isPackingDisable = false;
    this.invoice.isDebitDisable = false;
    const findDefault = this.saleMethodBranch?.SalePriceTypes.find((f) => f.IsDefault);
    if (findDefault) this.invoice.SalePriceTypeId = findDefault.SalePriceTypeId;
    else this.invoice.SalePriceTypeId = this.salePriceType[0]?.Id;
    this.setValue(`SalePriceTypeId`, this.invoice.SalePriceTypeId);
    this.invoice.TotalService = 0;
    if (withSetActivePage) this.setActivePage();
    if (this.saleMethodList && this.saleMethodList.length > 0)
      this.currentsaleMethodList = this.saleMethodList.filter((f) => f.Id === this.oldSaleMethodBranchId);
    let findDefaultItemCategory = this.saleMethodBranch.ItemCategories.find((f) => f.IsDefault);
    this.itemCategoryList?.forEach((element) => {
      element.Items.forEach((ele) => {
        ele.InvoiceQty = null;
      });
    });
    if (findDefaultItemCategory)
      this.selectedItemCategory = Object.assign(
        this.itemCategoryList.find((f) => f.Id === (findDefaultItemCategory.Category?.ParentId || findDefaultItemCategory.CategoryId))
      );
    else {
      this.selectedItemCategory = Object.assign([], this.itemCategoryList[0]);
    }
    this.focusInput();
    this.validHappyHour = false;
    this.invoice.DiscountType = null;
    this.invoice.IsDiscountPercent = true;
    this.validFreeService = false;
    this.happyHourDiscountValidation();
    this.detectChanges();
    this.SalePriceChange(this.invoice.SalePriceTypeId);
    this.getMaxInvoiceCode();
  }
  happyHourDiscountValidation() {
    if (this.invoice.Id) {
      this.validHappyHour = this.invoice.DiscountType == DiscountTypeEnum.HappyHour;
      this.validFreeService = !this.invoice.Service && this.validHappyHour && this.invoice.IgnoreService;
      return;
    }
    if (this.saleMethodBranch?.HasHappyHour) {
      let nowWeekDay = moment(new Date()).locale("fa").weekday();
      let nowTime = moment(new Date()).format("HH:mm:ss").split(":");
      let nowDate = new Date().setHours(0, 0, 0, 0);
      let startTime = moment(this.saleMethodBranch?.HappyHourStart).format("HH:mm:ss").split(":");
      let endTime = moment(this.saleMethodBranch?.HappyHourEnd).format("HH:mm:ss").split(":");
      let startDate = new Date(this.saleMethodBranch?.HappyHourFromDate).setHours(0, 0, 0, 0);
      let endDate = new Date(this.saleMethodBranch?.HappyHourToDate).setHours(0, 0, 0, 0);
      let containWeek: boolean = false;
      let unselectedWeek: boolean = true;
      if (this.saleMethodBranch.DaysOfWeek && this.saleMethodBranch.DaysOfWeek?.length != 0) {
        containWeek = String(this.saleMethodBranch.DaysOfWeek)
          ?.split(",")
          .map((e) => Number(e))
          .includes(nowWeekDay);
        unselectedWeek = false;
      } else unselectedWeek = true;
      if (
        this.saleMethodBranch.FreeShipping &&
        startDate <= nowDate &&
        endDate >= nowDate &&
        startTime <= nowTime &&
        endTime >= nowTime &&
        ((containWeek && !unselectedWeek) || (!containWeek && unselectedWeek))
      ) {
        this.validFreeShipping = true;
      }
      if (this.invoice.Items.length > 0 && this.invoice.Items.some((c) => c.ApplyService)) {
        if (
          this.saleMethodBranch.FreeService &&
          startDate <= nowDate &&
          endDate >= nowDate &&
          startTime <= nowTime &&
          endTime >= nowTime &&
          ((containWeek && !unselectedWeek) || (!containWeek && unselectedWeek))
        ) {
          this.validFreeService = true;
        }
      }
      if (
        this.validFreeShipping ||
        this.validFreeService ||
        (this.saleMethodBranch.Discount &&
          startDate <= nowDate &&
          endDate >= nowDate &&
          startTime <= nowTime &&
          endTime >= nowTime &&
          ((containWeek && !unselectedWeek) || (!containWeek && unselectedWeek)))
      )
        this.validHappyHour = true;
    }
  }
  async getMaxInvoiceCode(branchId?: number, callGetItemCategory?: boolean, isFirstGet = false) {
    if (!this.lastInformationIsLoading) {
      this.lastInformationIsLoading = true;
      this.httpCommonService
        .create("Invoice/GetLastInvoiceInformation", {
          Id: this.invoice.SaleMethodBranchId,
          BranchId: branchId,
        })
        .pipe(
          take(1),
          tap((res) => {
            this.lastInvoiceInformation = res;
            this.invoice.LastInvoiceCode = res?.Code;
            this.invoice.LastInvoiceAmount = res?.Amount;
            this.DelinoInvoiceCount = res?.DelinoInvoiceCount;
            this.detectChanges();
          })
        )
        .subscribe(async (res: any) => {
          this.lastInformationIsLoading = false;
          if (callGetItemCategory) this.GetItemCategoryList(isFirstGet);
        });
    }
  }

  hasDependents() {
    if (!this.saleMethodBranch.IncludeItemDependency && !this.saleMethodBranch.IncludeFreeItemDependency) {
      this.invoice.Items = this.invoice.Items?.filter((f) => !f.IsDependent);
      return;
    }
    if (!this.saleMethodBranch.IncludeItemDependency) {
      this.invoice.Items = this.invoice.Items?.filter((f) => !f.IsDependent && f.Price !== 0);
      return;
    }
    if (!this.saleMethodBranch.IncludeFreeItemDependency) {
      this.invoice.Items = this.invoice.Items?.filter((f) => !f.IsDependent && f.Price !== 0);
      return;
    }
  }
  SalePriceChange(salepricetypeid: number, isFirstGet: boolean = false) {
    if (this.invoice.SalePriceTypeId !== salepricetypeid || isFirstGet) {
      this.invoice.SalePriceTypeId = salepricetypeid;
      //Change Item Price
      this.itemCategoryList?.forEach((ic) => {
        ic.Items.forEach((i) => {
          this.setDefultPrice(i);
          if (this.selectedOrderItem && this.selectedOrderItem?.Additive?.length > 0) {
            this.selectedOrderItem.Additive.forEach((additive) => {
              const find_price = additive.Prices.find((f) => f.SalePriceTypeId === this.invoice.SalePriceTypeId);
              if (find_price) {
                additive.MainPrice = find_price.Price;
              } else additive.MainPrice = additive.Prices.find((f) => f.IsDefault).Price;
            });
          }
          if (i.ItemChild && i.ItemChild.length > 0) {
            i.ItemChild.forEach((itemchild) => {
              this.setDefultPrice(itemchild);
            });
          }
        });
      });
    }
    this.calculate();
    if (this.invoice.Id) this.invoiceChanged = true;
    this.checkInvoiceState(this.invoice.CommandCode);
    this.cd.markForCheck();
  }
  setDefultPrice(i: OrderItem) {
    if (!i.Prices || i.Prices.length <= 0) return;
    const find_price = i.Prices.find((f) => f.SalePriceTypeId === this.invoice.SalePriceTypeId);
    if (find_price) i.DetaultPrice = find_price.Price;
    else i.DetaultPrice = i.Prices.find((f) => f.IsDefault).Price;

    i.Additive.forEach((el) => {
      const find_Additive_PriceType = el.Prices.find((f) => f.SalePriceTypeId === this.invoice.SalePriceTypeId);
      if (find_Additive_PriceType) el.MainPrice = find_Additive_PriceType.Price;
      else el.MainPrice = el.Prices.find((f) => f.IsDefault).Price;
    });
    //Change InvoiceItem Price
    const find_invoice_item = this.invoice.Items.filter((f) => f.ItemId === i.Id);
    if (find_invoice_item && find_invoice_item.length > 0) {
      find_invoice_item.forEach((fi) => {
        if (!fi.IsDependent) fi.IsDependent = fi.Id && fi.TotalPrice === 0;
        this.invoice.Items.find((f) => f.ItemId === fi.ItemId && f.Index === fi.Index).UnitPrice = i.DetaultPrice;
        if (fi.TotalPrice === 0 && fi.IsDependent) {
          let InvoiceDependentList = [];
          this.invoice.Items.forEach((fr) => {
            let item = this.itemCategoryList[0]?.Items?.find(
              (f) =>
                f.Id === fr.ItemId &&
                f.Dependents?.some((s) => s.DependentItem.Id === fi.ItemId && s.ItemDependencyTypeCode === ItemDependencyType.Free)
            )?.Dependents?.find((s) => s.DependentItem.Id === fi.ItemId && s.ItemDependencyTypeCode === ItemDependencyType.Free);
            if (!item) {
              let bundle = this.itemCategoryList[0]?.Items?.find(
                (f) =>
                  f.ItemChild !== null &&
                  f.ItemChild.some(
                    (fs) =>
                      fs.Id === fr.ItemId &&
                      fs.Dependents?.some((s) => s.DependentItem.Id === fi.ItemId && s.ItemDependencyTypeCode === ItemDependencyType.Free)
                  )
              );
              item = bundle?.ItemChild?.find(
                (f) =>
                  f.Id === fr.ItemId &&
                  f.Dependents?.some((s) => s.DependentItem.Id === fi.ItemId && s.ItemDependencyTypeCode === ItemDependencyType.Free)
              )?.Dependents?.find((s) => s.DependentItem.Id === fi.ItemId && s.ItemDependencyTypeCode === ItemDependencyType.Free);
            }
            if (item) InvoiceDependentList.push(item);
          });
          const findParentIncludeDependent =
            InvoiceDependentList.some((s) => s.DependentItemId === fi.ItemId) &&
            InvoiceDependentList.find((s) => s.DependentItemId === fi.ItemId).Quantity <= fi.Quantity;
          if (findParentIncludeDependent) {
            this.invoice.Items.find((f) => f.ItemId === fi.ItemId && f.Index === fi.Index).UnitPrice = 0;
          }
        }
        fi.Additives.forEach((add) => {
          const find_add = i.Additive.find((find_add) => find_add.Id === add.AdditiveId);
          if (find_add) {
            const findAdditivePriceType = find_add.Prices.find((f) => f.SalePriceTypeId === this.invoice.SalePriceTypeId);
            if (findAdditivePriceType) add.UnitPrice = findAdditivePriceType.Price;
            else add.UnitPrice = find_add.Prices.find((f) => f.IsDefault).Price;
          }
          add.UnitPrice = find_add.MainPrice;
        });
      });
    }
  }
  // action like UseSalepriceTypeOtherTanDefualt
  public HasAccess(action: string): boolean {
    let hasAccess: boolean = true;
    hasAccess = this.accountService.userHasPermission(`RestaurantSale:Invoice_${this.saleMethodBranch.SaleMethodId}`, action);
    if (
      action.includes("OrderingStatus") ||
      action.includes("ClearStatus") ||
      action.includes("ClearedStatus") ||
      action.includes("ClearingStatus") ||
      action.includes("AssignedStatus") ||
      action.includes("PendingStatus")
    ) {
      switch (this.invoice.StatusCode) {
        case InvoiceStatus.Ordering:
          if (action.includes("OrderingStatus")) return hasAccess;
          if (action.includes("AssignedStatus")) return false;
          if (action.includes("ClearStatus") || action.includes("ClearedStatus")) return false;
          if (action.includes("ClearingStatus")) return false;
          if (action.includes("PendingStatus")) return false;
          return true;
        case InvoiceStatus.Clearing:
          if (action.includes("ClearingStatus")) return hasAccess;
          if (action.includes("OrderingStatus")) return false;
          if (action.includes("AssignedStatus")) return false;
          if (action.includes("ClearStatus") || action.includes("ClearedStatus")) return false;
          if (action.includes("PendingStatus")) return false;
          return true;
        case InvoiceStatus.Cleared:
          if (action.includes("ClearStatus") || action.includes("ClearedStatus") || action === "ClearClearingStatus") return hasAccess;
          if (action.includes("AssignedStatus")) return false;
          if (action.includes("OrderingStatus")) return false;
          if (action.includes("PendingStatus")) return false;
          if (action.includes("ClearingStatus")) return false;
          return true;
        case InvoiceStatus.Assigned:
          if (action.includes("AssignedStatus")) return hasAccess;
          if (action.includes("OrderingStatus")) return false;
          if (action.includes("ClearStatus") || action.includes("ClearedStatus")) return false;
          if (action.includes("PendingStatus")) return false;
          if (action.includes("ClearingStatus")) return false;
          return true;
        case InvoiceStatus.Pending:
          if (action.includes("PendingStatus")) return hasAccess;
          if (action.includes("AssignedStatus")) return true;
          if (action.includes("OrderingStatus")) return true;
          if (action.includes("ClearStatus") || action.includes("ClearedStatus")) return true;
          if (action.includes("ClearingStatus")) return true;
          return true;
        default:
          return true;
      }
    } else return hasAccess;
  }

  clubcount: number = 1;

  calculate(isNewCalculate?: boolean, clearDiscount: boolean = false) {
    this.shouldCalculate = true;
    if (this.invoice.Id) this.validHappyHour = this.invoice.DiscountType == DiscountTypeEnum.HappyHour;
    if (!this.currentBranch) return;
    this.setValueQuantity();
    if (this.invoice.Total < this.invoice.PackingPrice) {
      this.setValue("PackingPrice", this.invoice.Total);
    }
    var PayableTotal: number = 0;
    var roundingTemp: number = 0;
    var roundingTemp: number = 0;
    this.invoice.ApplyTaxForService = this.saleMethodBranch.ApplyTaxForService ?? false;
    this.invoice.ApplyTaxForShippingCost = this.saleMethodBranch.ApplyTaxForShippingCost ?? false;
    if (!this.isMultiBranch) {
      this.invoice.BranchId = this.currentBranch.Id;
    }
    this.invoice.TaxRate = this.currentBranch.TaxPercentage;
    this.invoice.TollRate = this.currentBranch.TollPercentage;
    this.invoice.ServiceRate = this.currentBranch.ServicePercentage;
    this.invoice.Total = 0;
    this.invoice.TotalWidthRowDiscount = 0;
    this.invoice.TotalDiscount = 0;
    this.invoice.TotalNet = 0;
    this.invoice.TotalTax = 0;
    this.invoice.TotalToll = 0;
    this.invoice.ServiceTax = 0;
    this.invoice.ShippingCostTax = 0;
    this.invoice.RoundingAmount = 0;
    this.invoice.Service = this.invoice.TotalService;
    this.invoice.TotalService = 0;
    let PackingPriceTax: number = 0;
    let UnitAdditiveServicePrice: number = 0;
    let additivePrice: number = 0;
    let UnitItemtaxPrice: number = 0;
    let UnitItemServicetaxPrice: number = 0;
    let UnitAdditiveServicetollPrice: number = 0;
    let UnitAdditivetaxPrice: number = 0;
    let UnitItemRowDiscountPrice: number = 0;
    let UnitItemServicePrice: number = 0;
    /// محاسبه مبلغ کل کالا به همراه تخفیف هر ایتم و مخلفات
    if (this.invoice?.Items?.length <= 0 && this.saleMethodBranch.ApplyPackingPrice) {
      this.setValue("PackingPrice", 0);
    }

    this.invoice.Items.forEach((item) => {
      if (item?.IsClubItem && item?.RowDiscount > 0 && !this.formGroup.controls[`RowDiscount${item.Index}`]?.value)
        this.setValue(`RowDiscount${item.Index}${this.invoice.SaleMethodBranchId}`, item.RowDiscount);

      ///RowDiscount تخفیف ردیفی
      if (Number(this.formGroup.controls[`RowDiscount${item.Index}${this.invoice.SaleMethodBranchId}`]?.value) > 100)
        this.setValue(`RowDiscount${item.Index}${this.invoice.SaleMethodBranchId}`, 100);
      item.RowDiscount = this.formGroup.controls[`RowDiscount${item.Index}${this.invoice.SaleMethodBranchId}`]?.value;
      item.RowDiscount = Number(item.RowDiscount) ? Number(item.RowDiscount) : 0;
      item.RowDiscount = !this.currentBranch.HasAuditorInSalesAmounts ? Math.round(item.RowDiscount) : parseFloat(item.RowDiscount?.toFixed(4));
      //بدست آوردن قیمت مخلفات
      item.UnitAdditive = 0;
      item.additivePrice = 0;
      item.UnitAdditiveServicePrice = 0;
      item.RowDiscountPrice = 0;
      item.UnitAdditiveRowDiscountPrice = 0;
      item.Price = 0;
      item.AdditiveUnitDiscount = 0;
      item.UnitAdditiveApplyTaxPrice = 0;
      item.UnitService = 0;
      item.ItemTotal = 0;
      item.TotalPrice = 0;
      item.UnitTax = 0;
      item.UnitToll = 0;

      if (item?.Additives?.length > 0) {
        item.Additives.forEach((addi) => {
          addi.PackingPrice = 0;
          addi.UnitDiscount = 0;
          addi.UnitTax = 0;
          addi.UnitToll = 0;
          addi.UnitService = 0;
          addi.Tax = addi.Tax == 0 ? this.invoice.TaxRate : addi.Tax;
          addi.Toll = addi.Toll == 0 ? this.invoice.TollRate : addi.Toll;
          item.UnitAdditive += addi.MainPrice ? addi.MainPrice : addi.UnitPrice;
          addi.UnitRowDiscount = item.RowDiscount > 0 ? ((addi.MainPrice ? addi.MainPrice : addi.UnitPrice) * item.RowDiscount) / 100 : 0;
          additivePrice = ((addi.MainPrice ? addi.MainPrice : addi.UnitPrice) - addi.UnitRowDiscount) * item.Quantity;
          item.additivePrice += additivePrice;
          addi.RowDiscount = item.RowDiscount;
          addi.Service = this.invoice.ServiceRate;
          UnitAdditiveServicePrice =
            this.saleMethodBranch.ApplyService && addi.ApplyService ? (addi.MainPrice ? addi.MainPrice : addi.UnitPrice) - addi.UnitRowDiscount : 0;
          item.UnitAdditiveServicePrice += UnitAdditiveServicePrice;
          item.UnitAdditiveRowDiscountPrice += addi.UnitRowDiscount;
          item.UnitAdditiveApplyTaxPrice +=
            this.saleMethodBranch.ApplyTax && addi.ApplyTax ? (addi.MainPrice ? addi.MainPrice : addi.UnitPrice) - addi.UnitRowDiscount : 0;
        });
      }
      UnitItemRowDiscountPrice += item.RowDiscount > 0 ? (item.UnitPrice * item.RowDiscount) / 100 : 0;
      UnitItemServicePrice += item.ApplyService && this.saleMethodBranch.ApplyService ? (item.UnitPrice * this.invoice.ServiceRate) / 100 : 0;

      // هزینه بسته بندی
      if (this.saleMethodBranch.ApplyPackingPrice) {
        let sumRowPackingPrice: number = 0;
        let ModifysumRowPackingPrice: number = 0;
        if (this.invoice.State === RowState.Modify && !this.invoice.isPackingDisable && !this.invoice.isPackingAutoCalc) {
          this.invoice.Items.forEach((element) => (sumRowPackingPrice += element.PackingPrice * element.Quantity));
          this.invoice.Items.forEach(
            (element) => (ModifysumRowPackingPrice += element.State === RowState.NoChange ? element.PackingPrice * element.Quantity : 0)
          );
          if (ModifysumRowPackingPrice === this.invoice.PackingPrice && this.invoice.PackingPrice > 0) {
            this.invoice.isPackingAutoCalc = true;
          } else {
            if (sumRowPackingPrice !== this.invoice.PackingPrice) {
              sumRowPackingPrice = this.invoice.PackingPrice;
            }
          }
        } else {
          if (!this.invoice.isPackingDisable) {
            this.invoice.Items.forEach((element) => (sumRowPackingPrice += element.PackingPrice * element.Quantity));
          } else {
            sumRowPackingPrice = this.formGroup.controls["PackingPrice"].value;
          }
        }

        this.invoice.PackingPrice = sumRowPackingPrice;
        this.setValue("PackingPrice", sumRowPackingPrice);
      } else {
        this.invoice.PackingPrice = 0;
        this.setValue("PackingPrice", 0);
      }
      //Discount item
      //تخفیف درصدی هر آیتم
      if (item.RowDiscount !== 0) {
        item.RowDiscountPrice = !this.currentBranch.HasAuditorInSalesAmounts
          ? Math.round(((item.UnitPrice + item.UnitAdditive) * item.RowDiscount) / 100)
          : parseFloat((((item.UnitPrice + item.UnitAdditive) * item.RowDiscount) / 100)?.toFixed(4));
        item.RowDiscountPrice = !this.currentBranch.HasAuditorInSalesAmounts
          ? Math.round(((item.UnitPrice + item.UnitAdditive) * item.RowDiscount) / 100)
          : parseFloat((((item.UnitPrice + item.UnitAdditive) * item.RowDiscount) / 100)?.toFixed(4));
      }
      ///بدست اوردن جمع کالاهای سبد
      //بدست آوردن جمع ناخالص هر سطر

      this.invoice.Total += (item.UnitPrice + item.UnitAdditive - item.RowDiscountPrice) * item.Quantity;
      this.invoice.Total = !this.currentBranch.HasAuditorInSalesAmounts ? Math.round(this.invoice.Total) : parseFloat(this.invoice.Total?.toFixed(4));
      item.Price = (item.UnitPrice - (item.UnitPrice * item.RowDiscount) / 100) * item.Quantity;
      item.ItemTotal = (item.UnitPrice + item.UnitAdditive - ((item.UnitPrice + item.UnitAdditive) * item.RowDiscount) / 100) * item.Quantity;

      this.invoice.TotalWidthRowDiscount += (item.UnitPrice + item.UnitAdditive - item.RowDiscountPrice) * item.Quantity;
    });

    /// محاسبه تخفیف وارد شده در فاکتور به صورت کلی
    this.applyOrganizationDiscount();

    if (this.invoice.DiscountType !== DiscountTypeEnum.None && this.invoice.DiscountType !== DiscountTypeEnum.User) {
      this.calculateDiscount();
    }

    if (clearDiscount) this.invoice.Discount = 0;

    if (this.invoice.Discount != null) {
      if (this.invoice.IsDiscountPercent) {
        if (this.invoice.Discount > 100) this.invoice.Discount = 100;
        this.invoice.DiscountPrice = (this.invoice.Total * this.invoice.Discount) / 100;
      } else {
        if (this.invoice.Discount > this.invoice.Total + this.invoice.PackingPrice + this.invoice.ShippingCost) {
          this.shouldCalculate = false;
          this.invoice.Discount = this.invoice.Total + this.invoice.PackingPrice + this.invoice.ShippingCost;
        } else {
          this.invoice.Discount =
            this.formGroup.controls["Discount"].value > this.invoice.Total ? this.invoice.Total : this.formGroup.controls["Discount"].value;
        }
        this.invoice.DiscountPrice = this.invoice.Discount;
      }
    } else this.invoice.DiscountPrice = 0;
    this.formGroup.controls["Discount"].setValue(this.invoice.Discount);
    this.invoice.DiscountPrice = !this.currentBranch.HasAuditorInSalesAmounts
      ? Math.round(this.invoice.DiscountPrice)
      : parseFloat(this.invoice.DiscountPrice.toFixed(4));
    /// محاسبه خالص هر کالا
    this.invoice.Items.forEach((item) => {
      //Discount header
      //تسهیم تخفیف کلی فاکتور بر روی هر واحد از آیتم
      if (this.invoice.Total > 0 && item.UnitPrice > 0 && item.Quantity > 0 && item.Free === false) {
        item.UnitDiscount = ((this.invoice.DiscountPrice / this.invoice.Total) * item.Price) / item.Quantity;
        item.UnitDiscount = !this.currentBranch.HasAuditorInSalesAmounts ? Math.round(item.UnitDiscount) : parseFloat(item.UnitDiscount?.toFixed(4));
        item.AdditiveUnitDiscount = ((this.invoice.DiscountPrice / this.invoice.Total) * item.additivePrice) / item.Quantity;
        item.AdditiveUnitDiscount = !this.currentBranch.HasAuditorInSalesAmounts
          ? Math.round(item.AdditiveUnitDiscount)
          : parseFloat(item.AdditiveUnitDiscount?.toFixed(4));
        item.AdditiveUnitDiscount = !this.currentBranch.HasAuditorInSalesAmounts
          ? Math.round(item.AdditiveUnitDiscount)
          : parseFloat(item.AdditiveUnitDiscount?.toFixed(4));
        item.AdditiveServiceUnitDiscount = (this.invoice.DiscountPrice / this.invoice.Total) * item.UnitAdditiveServicePrice;
        item.AdditiveServiceUnitDiscount = !this.currentBranch.HasAuditorInSalesAmounts
          ? Math.round(item.AdditiveServiceUnitDiscount)
          : parseFloat(item.AdditiveServiceUnitDiscount?.toFixed(4));
        item.AdditiveServiceUnitDiscount = !this.currentBranch.HasAuditorInSalesAmounts
          ? Math.round(item.AdditiveServiceUnitDiscount)
          : parseFloat(item.AdditiveServiceUnitDiscount?.toFixed(4));
      }
      if (item.UnitDiscount > item.UnitPrice) item.UnitDiscount = item.UnitPrice;
      /// service
      //بدست آوردن میزان سرویس هر آیتم و جمع مبالغ سرویس
      if (this.invoice.IgnoreService === false && this.saleMethodBranch.ApplyService === true && this.invoice.ServiceRate > 0) {
        if (item.ApplyService || item.Additives.some((s) => s.ApplyService)) {
          item.UnitService =
            (((item.ApplyService ? item.Price / item.Quantity : 0) +
              item.UnitAdditiveServicePrice -
              item.AdditiveServiceUnitDiscount -
              (item.ApplyService && !this.validFreeService ? item.UnitDiscount : 0)) *
              this.invoice.ServiceRate) /
            100;
        } else {
          if (item.UnitAdditiveServicePrice > 0) {
            item.UnitService = ((item.UnitAdditiveServicePrice - item.AdditiveServiceUnitDiscount) * this.invoice.ServiceRate) / 100;
          }
        }
        item.UnitService = !this.currentBranch.HasAuditorInSalesAmounts ? Math.round(item.UnitService) : parseFloat(item.UnitService?.toFixed(4));
        if (!item.UnitService) item.UnitService = 0;
      }
      if (this.invoice.IgnoreService === true) item.UnitService = 0;
      // Tax مالیات
      //بدست آوردن مالیات هر آیتم
      UnitAdditivetaxPrice = 0;
      UnitItemServicetaxPrice = 0;
      if (this.invoice.TaxRate > 0 && this.saleMethodBranch.ApplyTax === true) {
        UnitItemtaxPrice = 0;

        if ((item.ApplyService || item.Additives.some((s) => s.ApplyService)) && this.saleMethodBranch.ApplyTaxForService)
          UnitItemServicetaxPrice =
            !this.validFreeService && this.saleMethodBranch.ApplyTaxForService && (item.ApplyService || item.Additives.some((s) => s.ApplyService))
              ? (item.UnitService * this.invoice.TaxRate) / 100
              : 0;
        if (!UnitItemServicetaxPrice) UnitItemServicetaxPrice = 0;
        if (item.ApplyTax) {
          if (item.UnitPrice - (item.UnitPrice * item.RowDiscount) / 100 - item.UnitDiscount < 0) {
            UnitItemtaxPrice = 0;
          } else
            UnitItemtaxPrice =
              ((item.UnitPrice - (item.UnitPrice * item.RowDiscount) / 100 - item.UnitDiscount) * (item.Tax ? item.Tax : this.invoice.TaxRate)) / 100; //+ UnitItemServicetaxPrice;
          UnitItemtaxPrice = !this.currentBranch.HasAuditorInSalesAmounts ? Math.floor(UnitItemtaxPrice) : parseFloat(UnitItemtaxPrice.toFixed(4));
        }
        if (!UnitItemtaxPrice) UnitItemtaxPrice = 0;

        item?.Additives?.forEach((addi) => {
          const RowAfterDiscountValue = (addi.MainPrice ? addi.MainPrice : addi.UnitPrice) - addi.UnitRowDiscount;
          let additivediscountPrice = (this.invoice.DiscountPrice / this.invoice.Total) * RowAfterDiscountValue;
          if (!additivediscountPrice) additivediscountPrice = 0;
          if (addi.ApplyTax) {
            UnitAdditivetaxPrice +=
              addi.ApplyTax && this.saleMethodBranch.ApplyTax
                ? ((RowAfterDiscountValue - additivediscountPrice) * (addi.Tax ? addi.Tax : this.invoice.TaxRate)) / 100
                : 0;
          }
        });
        item.UnitTax = UnitItemtaxPrice + UnitAdditivetaxPrice + UnitItemServicetaxPrice;
        item.UnitTax = !this.currentBranch.HasAuditorInSalesAmounts ? Math.floor(item.UnitTax) : parseFloat(item.UnitTax?.toFixed(4));
      }

      // Toll عوارض
      // بدست آوردن عوارض هر آیتم
      let itemToll: number = 0;
      UnitAdditiveServicetollPrice = 0;
      let UnitItemServicetollPrice: number = 0;
      if ((this.invoice.TollRate || item.Toll) > 0 && this.saleMethodBranch.ApplyTax === true) {
        UnitItemtaxPrice = 0;
        if ((item.ApplyService || item.Additives.some((s) => s.ApplyService)) && this.saleMethodBranch.ApplyTaxForService) {
          UnitItemServicetollPrice =
            !this.validFreeService && this.saleMethodBranch.ApplyTaxForService && (item.ApplyService || item.Additives.some((s) => s.ApplyService))
              ? (item.UnitService * (item.Toll ? item.Toll : this.invoice.TollRate)) / 100
              : 0;
          UnitItemServicetollPrice = !this.currentBranch.HasAuditorInSalesAmounts
            ? Math.floor(UnitItemServicetollPrice)
            : parseFloat(UnitItemServicetollPrice.toFixed(4));
        }
        if (item.ApplyTax) {
          itemToll =
            ((item.UnitPrice - (item.UnitPrice * item.RowDiscount) / 100 - item.UnitDiscount) * (item.Toll ? item.Toll : this.invoice.TollRate)) /
            100;
          itemToll = !this.currentBranch.HasAuditorInSalesAmounts ? Math.floor(itemToll) : parseFloat(itemToll.toFixed(4));
        }
        let addToll = 0;
        item?.Additives?.forEach((addi) => {
          const RowAfterDiscountValue = (addi.MainPrice ? addi.MainPrice : addi.UnitPrice) - addi.UnitRowDiscount;
          const additivediscountPrice = (this.invoice.DiscountPrice / this.invoice.Total) * RowAfterDiscountValue;
          if (addi.ApplyTax) {
            addToll +=
              addi.ApplyTax && this.saleMethodBranch.ApplyTax
                ? ((RowAfterDiscountValue - additivediscountPrice) * (addi.Toll ? addi.Toll : this.invoice.TollRate)) / 100
                : 0;
          }
        });

        item.UnitToll = itemToll + addToll + UnitItemServicetollPrice + UnitAdditiveServicetollPrice;
        item.UnitToll = !this.currentBranch.HasAuditorInSalesAmounts ? Math.floor(item.UnitToll) : parseFloat(item.UnitToll?.toFixed(4));
      }

      //محاسبه خالص مبلغ کالا
      let hasChangePrice: boolean = false;
      if (this.invoice.Id && this.invoice.OriginalValue?.Items?.find((c) => c.Id == item.Id)) {
        hasChangePrice = this.invoice.SalePriceTypeId != this.invoice.OriginalValue.SalePriceTypeId;
      }
      item.UnitPrice =
        this.invoice.Id && this.invoice.OriginalValue.Items.find((c) => c.Id == item.Id) && !hasChangePrice
          ? this.invoice.OriginalValue.Items.find((c) => c.Id == item.Id).UnitPrice
          : item.UnitPrice;
      item.UnitPrice = !this.currentBranch.HasAuditorInSalesAmounts ? Math.round(item.UnitPrice) : parseFloat(item.UnitPrice?.toFixed(4));
      item.UnitPrice = !this.currentBranch.HasAuditorInSalesAmounts ? Math.round(item.UnitPrice) : parseFloat(item.UnitPrice?.toFixed(4));
      item.TotalPrice =
        (item.UnitPrice +
          item.UnitAdditive +
          (this.validFreeService && !this.invoice.IgnoreService ? 0 : item.UnitService) +
          item.UnitTax +
          item.UnitToll -
          item.UnitDiscount -
          item.AdditiveUnitDiscount -
          item.RowDiscountPrice) *
        item.Quantity;
      item.TotalPrice = !this.currentBranch.HasAuditorInSalesAmounts ? Math.round(item.TotalPrice) : parseFloat(item.TotalPrice?.toFixed(4));
      //بدست آوردن جمع تخفیف
      if (item.UnitDiscount > 0 || item.RowDiscountPrice > 0) {
        this.invoice.TotalDiscount += (item.UnitDiscount + item.AdditiveUnitDiscount + item.RowDiscountPrice) * item.Quantity;
        this.invoice.TotalDiscount = !this.currentBranch.HasAuditorInSalesAmounts
          ? Math.round(this.invoice.TotalDiscount)
          : parseFloat(this.invoice.TotalDiscount?.toFixed(4));
        this.invoice.TotalDiscount = !this.currentBranch.HasAuditorInSalesAmounts
          ? Math.round(this.invoice.TotalDiscount)
          : parseFloat(this.invoice.TotalDiscount?.toFixed(4));
        item.TotalDiscount = (item.UnitDiscount + item.AdditiveUnitDiscount + item.RowDiscountPrice) * item.Quantity;
        item.TotalDiscount = !this.currentBranch.HasAuditorInSalesAmounts
          ? Math.round(item.TotalDiscount)
          : parseFloat(item.TotalDiscount?.toFixed(4));
        item.TotalDiscount = !this.currentBranch.HasAuditorInSalesAmounts
          ? Math.round(item.TotalDiscount)
          : parseFloat(item.TotalDiscount?.toFixed(4));
      }
      //جمع کالا و خدمات
      this.invoice.TotalNet += item.TotalPrice;
      this.invoice.TotalTax += item.UnitTax * item.Quantity;
      this.invoice.TotalToll += item.UnitToll * item.Quantity;
      this.invoice.TotalTax = !this.currentBranch.HasAuditorInSalesAmounts
        ? Math.floor(this.invoice.TotalTax)
        : parseFloat(this.invoice.TotalTax?.toFixed(4));
      this.invoice.TotalToll = !this.currentBranch.HasAuditorInSalesAmounts
        ? Math.floor(this.invoice.TotalToll)
        : parseFloat(this.invoice.TotalToll?.toFixed(4));
      this.invoice.TotalTax = !this.currentBranch.HasAuditorInSalesAmounts
        ? Math.floor(this.invoice.TotalTax)
        : parseFloat(this.invoice.TotalTax?.toFixed(4));
      this.invoice.TotalToll = !this.currentBranch.HasAuditorInSalesAmounts
        ? Math.floor(this.invoice.TotalToll)
        : parseFloat(this.invoice.TotalToll?.toFixed(4));
      if (this.saleMethodBranch.ApplyService) {
        this.invoice.TotalService += item.UnitService * item.Quantity;
        this.invoice.TotalService = !this.currentBranch.HasAuditorInSalesAmounts
          ? Math.round(this.invoice.TotalService)
          : parseFloat(this.invoice.TotalService?.toFixed(4));
        this.invoice.TotalService = !this.currentBranch.HasAuditorInSalesAmounts
          ? Math.round(this.invoice.TotalService)
          : parseFloat(this.invoice.TotalService?.toFixed(4));
      }
      this.invoice.TotalNet = !this.currentBranch.HasAuditorInSalesAmounts
        ? Math.round(this.invoice.TotalNet)
        : parseFloat(this.invoice.TotalNet?.toFixed(4));
      this.invoice.TotalNet = !this.currentBranch.HasAuditorInSalesAmounts
        ? Math.round(this.invoice.TotalNet)
        : parseFloat(this.invoice.TotalNet?.toFixed(4));
      // محاسبه جزییات ادیتیو
      if (item?.Additives?.length > 0) {
        item.Additives.forEach((addi) => {
          addi.UnitDiscount = (item.AdditiveUnitDiscount / item.UnitAdditive) * addi.UnitPrice;
          if (isNaN(addi.UnitDiscount)) addi.UnitDiscount = 0;
          addi.UnitService =
            ((item.UnitAdditiveServicePrice - (item.UnitPrice * item.RowDiscount) / 100 - item.AdditiveUnitDiscount - item.UnitDiscount) *
              this.invoice.ServiceRate) /
            100;
          addi.UnitService = !this.currentBranch.HasAuditorInSalesAmounts ? Math.round(addi.UnitService) : parseFloat(addi.UnitService?.toFixed(4));
          addi.UnitTax = (addi.MainPrice ? addi.MainPrice : addi.UnitPrice) - addi.UnitRowDiscount + addi.UnitService;

          addi.Tax = addi.Tax ? addi.Tax : this.invoice.TaxRate;
          addi.Toll = addi.Toll ? addi.Toll : this.invoice.TollRate;
          addi.RowDiscount = item.RowDiscount;
          if (!this.validFreeService && addi.ApplyService && this.saleMethodBranch.ApplyTaxForService) {
            const servicetax = (addi.UnitService * addi.Tax) / 100;
            addi.UnitTax += servicetax ? servicetax : 0;
            const servicetoll = (addi.UnitService * addi.Toll) / 100;
            addi.UnitToll += servicetoll ? servicetoll : 0;
          }
        });
      }
    });
    if (this.invoice.Discount > 0  && this.shouldCalculate) {
      const sumUnitDiscount = this.invoice.Items.map((e) => e.UnitDiscount * e.Quantity).reduce((acc, curr) => acc + curr, 0);
      if (this.invoice.DiscountPrice - sumUnitDiscount > 0 && this.invoice.DiscountPrice - sumUnitDiscount <= 100) {
        this.invoice.Items[0].TotalPrice -= this.invoice.DiscountPrice - sumUnitDiscount;
        this.invoice.Items[0].UnitDiscount += (this.invoice.DiscountPrice - sumUnitDiscount) / this.invoice.Items[0].Quantity;
        this.invoice.TotalDiscount += this.invoice.DiscountPrice - sumUnitDiscount;
        this.invoice.Items[0].UnitTax -= (this.invoice.DiscountPrice - sumUnitDiscount) / this.invoice.Items[0].Quantity;
        this.invoice.TotalTax = this.invoice.TotalTax
          ? this.invoice.TotalTax - (this.invoice.DiscountPrice - sumUnitDiscount)
          : this.invoice.TotalTax;
        this.invoice.TotalNet = this.invoice.TotalNet
          ? this.invoice.TotalNet - (this.invoice.DiscountPrice - sumUnitDiscount)
          : this.invoice.TotalNet;
      }
      if (this.invoice.DiscountPrice - sumUnitDiscount < 0 && this.invoice.DiscountPrice - sumUnitDiscount >= -100) {
        this.invoice.Items[0].TotalPrice += sumUnitDiscount - this.invoice.DiscountPrice;
        this.invoice.Items[0].UnitDiscount -= (sumUnitDiscount - this.invoice.DiscountPrice) / this.invoice.Items[0].Quantity;
        this.invoice.TotalDiscount -= sumUnitDiscount - this.invoice.DiscountPrice;
        this.invoice.Items[0].UnitTax += (sumUnitDiscount - this.invoice.DiscountPrice) / this.invoice.Items[0].Quantity;
        this.invoice.TotalTax = this.invoice.TotalTax
          ? this.invoice.TotalTax + (sumUnitDiscount - this.invoice.DiscountPrice)
          : this.invoice.TotalTax;
        this.invoice.TotalNet = this.invoice.TotalNet
          ? this.invoice.TotalNet + (sumUnitDiscount - this.invoice.DiscountPrice)
          : this.invoice.TotalNet;
      }
    }
    if (this.invoice.TotalTax > 0) {
      const sumUnitTax = this.invoice.Items.map((e) => e.UnitTax * e.Quantity).reduce((acc, curr) => acc + curr, 0);
      if (this.invoice.TotalTax - sumUnitTax > 0) {
        this.invoice.Items[0].UnitTax += (this.invoice.TotalTax - sumUnitTax) / this.invoice.Items[0].Quantity;
      }
      if (this.invoice.TotalTax - sumUnitTax < 0) {
        this.invoice.Items[0].UnitTax -= (sumUnitTax - this.invoice.TotalTax) / this.invoice.Items[0].Quantity;
      }
    }
    if (this.invoice.TotalToll > 0) {
      const sumUnitToll = this.invoice.Items.map((e) => e.UnitToll * e.Quantity).reduce((acc, curr) => acc + curr, 0);
      if (this.invoice.TotalToll - sumUnitToll > 0) {
        this.invoice.Items[0].UnitToll += (this.invoice.TotalToll - sumUnitToll) / this.invoice.Items[0].Quantity;
      }
      if (this.invoice.TotalToll - sumUnitToll < 0) {
        this.invoice.Items[0].UnitToll -= (sumUnitToll - this.invoice.TotalToll) / this.invoice.Items[0].Quantity;
      }
    }
    const sumUnitToll = this.invoice.Items.map((e) => e.UnitToll * e.Quantity).reduce((acc, curr) => acc + curr, 0);
    if (this.validFreeService && !this.invoice.IgnoreService) {
      this.invoice.TotalService = 0;
      this.validHappyHour = true;
      if (this.invoice.DiscountType !== DiscountTypeEnum.User) {
        this.invoice.DiscountType = DiscountTypeEnum.HappyHour;
      }
    }
    //محاسبه مالیات حق سرویس
    if (this.invoice.ApplyTaxForService && this.invoice.TotalService > 0) {
      this.invoice.ServiceTax = (this.invoice.TotalService * (this.invoice.TaxRate + this.invoice.TollRate)) / 100; //باید اضافه شود
      this.invoice.ServiceTax = !this.currentBranch.HasAuditorInSalesAmounts
        ? Math.floor(this.invoice.ServiceTax)
        : parseFloat(this.invoice.ServiceTax?.toFixed(4));
      this.invoice.ServiceTax = !this.currentBranch.HasAuditorInSalesAmounts
        ? Math.floor(this.invoice.ServiceTax)
        : parseFloat(this.invoice.ServiceTax?.toFixed(4));
    }
    /// less
    var FinalDiscount: number = 0;
    var FinalTax: number = 0;
    var PayableTotalLess =
      this.invoice.Total /*+ Taxless + Serviceless */ +
      this.invoice.PackingPrice +
      (this.currentSaleMethodNature === SaleMethodNature.Delivery ? this.invoice.ShippingCost : 0);
    var RowDiscount: number = 0;
    var DiffDiscount: number = 0;
    this.invoice.Items.forEach((ele) => {
      RowDiscount += ele.RowDiscountPrice * ele.Quantity;
    });
    if (this.invoice.IsDiscountPercent) {
      if (this.invoice.Items.filter((it) => it.IsOrganizationalDiscount)?.length && this.invoice.Customer.Category?.OrganizationalDiscount > 0) {
        FinalDiscount = (this.invoice.Total * this.formGroup.controls["Discount"].value) / 100;
      } else FinalDiscount = (PayableTotalLess * this.formGroup.controls["Discount"].value) / 100;
    } else {
      FinalDiscount = this.formGroup.controls["Discount"].value;
    }
    FinalDiscount = !this.currentBranch.HasAuditorInSalesAmounts ? Math.round(FinalDiscount) : parseFloat(FinalDiscount?.toFixed(4));
    this.invoice.RoundingAmount = !this.currentBranch.HasAuditorInSalesAmounts
      ? Math.round(this.invoice.RoundingAmount)
      : parseFloat(this.invoice.RoundingAmount?.toFixed(4));
    this.invoice.RoundingAmount = !this.currentBranch.HasAuditorInSalesAmounts
      ? Math.round(this.invoice.RoundingAmount)
      : parseFloat(this.invoice.RoundingAmount?.toFixed(4));
    let payableTotalLess = this.invoice.Total + this.invoice.PackingPrice + this.invoice.ShippingCost + this.invoice.RoundingAmount;
    this.invoice.PayableTotalLessDiscount = payableTotalLess;
    /// less
    if (
      this.invoice.TotalDiscount > 0 &&
      ((this.currentSaleMethodNature === SaleMethodNature.Delivery && this.invoice.ShippingCost > 0) || this.invoice.PackingPrice > 0) &&
      (this.invoice.IsDiscountPercent ||
        (!this.invoice.IsDiscountPercent && this.invoice.DiscountPrice + this.invoice.PackingPrice + this.invoice.ShippingCost > this.invoice.Total))
    ) {
      if (this.invoice.Total > FinalDiscount) DiffDiscount = 0;
      else DiffDiscount = FinalDiscount - this.invoice.Total;
      if (
        this.invoice.ShippingCost > 0 &&
        this.saleMethodBranch.ApplyTaxForShippingCost &&
        this.saleMethodBranch.ApplyTax &&
        this.saleMethodBranch.ApplyTaxForShippingCost
      ) {
        if (!this.invoice.IsDiscountPercent) {
          if (DiffDiscount > 0) {
            let ShippingCostTax =
              this.invoice.ShippingCost - (DiffDiscount / (this.invoice.PackingPrice + this.invoice.ShippingCost)) * this.invoice.ShippingCost;
            this.invoice.TotalTax += (ShippingCostTax * this.invoice.TaxRate) / 100;
            this.invoice.TotalToll += (ShippingCostTax * this.invoice.TollRate) / 100;
          } else {
            this.invoice.TotalTax += (this.invoice.ShippingCost * this.invoice.TaxRate) / 100;
            this.invoice.TotalToll += (this.invoice.ShippingCost * this.invoice.TollRate) / 100;
          }
        } else {
          const dis = this.invoice.ShippingCost - (this.invoice.ShippingCost * this.invoice.Discount) / 100;
          this.invoice.TotalTax += (dis * this.invoice.TaxRate) / 100;
          this.invoice.TotalToll += (dis * this.invoice.TollRate) / 100;
        }
      }
      this.invoice.TotalTax = Math.floor(this.invoice.TotalTax);
      this.invoice.TotalToll = Math.floor(this.invoice.TotalToll);
      if (
        this.invoice.PackingPrice > 0 &&
        this.saleMethodBranch.ApplyPackingPrice &&
        this.saleMethodBranch.ApplyTax &&
        this.saleMethodBranch.ApplyTaxForPackingPrice
      ) {
        if (!this.invoice.IsDiscountPercent) {
          if (DiffDiscount > 0) {
            let pTax =
              this.invoice.PackingPrice - (DiffDiscount / (this.invoice.PackingPrice + this.invoice.ShippingCost)) * this.invoice.PackingPrice;
            this.invoice.TotalTax += (pTax * this.invoice.TaxRate) / 100;
            this.invoice.TotalToll += (pTax * this.invoice.TollRate) / 100;
          } else {
            this.invoice.TotalTax += (this.invoice.PackingPrice * this.invoice.TaxRate) / 100;
            this.invoice.TotalToll += (this.invoice.PackingPrice * this.invoice.TollRate) / 100;
          }
        } else {
          const dis =
            (this.formGroup.controls["PackingPrice"].value ? this.formGroup.controls["PackingPrice"].value : 0) -
            ((this.formGroup.controls["PackingPrice"].value ? this.formGroup.controls["PackingPrice"].value : 0) * this.invoice.Discount) / 100;
          this.invoice.TotalTax += (dis * this.invoice.TaxRate) / 100;
          this.invoice.TotalToll += (dis * this.invoice.TollRate) / 100;
        }
      }
      this.invoice.TotalTax = Math.floor(this.invoice.TotalTax);
      this.invoice.TotalToll = Math.floor(this.invoice.TotalToll);
      if (!this.saleMethodBranch.ApplyPackingPrice) {
        this.invoice.PackingPrice = 0;
        this.setValue("PackingPrice", "");
      }
      this.invoice.TotalDiscount = Number(FinalDiscount) + (RowDiscount ? RowDiscount : 0);
      this.invoice.TotalDiscount = !this.currentBranch.HasAuditorInSalesAmounts
        ? Math.round(this.invoice.TotalDiscount)
        : parseFloat(this.invoice.TotalDiscount?.toFixed(4));
      this.invoice.TotalDiscount = !this.currentBranch.HasAuditorInSalesAmounts
        ? Math.round(this.invoice.TotalDiscount)
        : parseFloat(this.invoice.TotalDiscount?.toFixed(4));
      this.invoice.PayableTotal =
        this.invoice.Total +
        (this.formGroup.controls["PackingPrice"].value ? this.formGroup.controls["PackingPrice"].value : 0) +
        (this.currentSaleMethodNature === SaleMethodNature.Delivery ? this.invoice.ShippingCost : 0) +
        this.invoice.TotalService +
        this.invoice.TotalTax +
        this.invoice.TotalToll -
        FinalDiscount;
      PayableTotal = this.invoice.PayableTotal;
      PayableTotal = !this.currentBranch?.HasAuditorInSalesAmounts ? Math.round(PayableTotal) : parseFloat(PayableTotal?.toFixed(4));
    } else {
      //محاسبه مالیات هزینه بسته بندی
      if (this.saleMethodBranch.ApplyTax && this.saleMethodBranch.ApplyTaxForPackingPrice && this.formGroup.controls["PackingPrice"].value > 0) {
        PackingPriceTax = (this.formGroup.controls["PackingPrice"]?.value * (this.invoice.TaxRate + this.invoice.TollRate)) / 100; //باید اضافه شود
        PackingPriceTax = !this.currentBranch.HasAuditorInSalesAmounts ? Math.floor(PackingPriceTax) : parseFloat(PackingPriceTax?.toFixed(4));
      }
      //محاسبه مالیات کرایه
      if (
        this.saleMethodBranch.ApplyTax &&
        this.saleMethodBranch.ApplyTaxForShippingCost === true &&
        this.invoice.ShippingCost > 0 &&
        !this.invoice.IgnoreShippingCost
      ) {
        this.invoice.ShippingCostTax = (this.invoice.ShippingCost * (this.invoice.TaxRate + this.invoice.TollRate)) / 100;
      }
      this.invoice.TotalTax += PackingPriceTax;
      this.invoice.TotalTax += this.invoice.ShippingCostTax;
      this.invoice.TotalTax = !this.currentBranch.HasAuditorInSalesAmounts
        ? Math.floor(this.invoice.TotalTax)
        : parseFloat(this.invoice.TotalTax?.toFixed(4));
      this.invoice.TotalTax = !this.currentBranch.HasAuditorInSalesAmounts
        ? Math.floor(this.invoice.TotalTax)
        : parseFloat(this.invoice.TotalTax?.toFixed(4));
      /// بدست اوردن جمع برای مبلغ گرد کردن
      PayableTotal =
        this.invoice.TotalNet +
        (this.formGroup.controls["PackingPrice"]?.value ? this.formGroup.controls["PackingPrice"]?.value : 0) +
        PackingPriceTax +
        (this.currentSaleMethodNature === this.SaleMethodNature.Delivery ? (this.invoice.ShippingCost ? this.invoice.ShippingCost : 0) : 0) +
        (this.currentSaleMethodNature === this.SaleMethodNature.Delivery ? (this.invoice.ShippingCostTax ? this.invoice.ShippingCostTax : 0) : 0);
      PayableTotal = !this.currentBranch?.HasAuditorInSalesAmounts ? Math.round(PayableTotal) : parseFloat(PayableTotal?.toFixed(4));
    }

    //مبلغ گرد شدن
    if (this.currentBranch.RoundingAmount > 0 && PayableTotal > 0 && PayableTotal % this.currentBranch.RoundingAmount !== 0) {
      //استاندارد
      if (this.currentBranch.RoundingTypeCode === 0) {
        roundingTemp = PayableTotal % this.currentBranch.RoundingAmount;
        if (roundingTemp >= this.currentBranch.RoundingAmount / 2) this.invoice.RoundingAmount = this.currentBranch.RoundingAmount - roundingTemp;
        else this.invoice.RoundingAmount = roundingTemp * -1;
      }
      //رو به بالا
      else if (this.currentBranch.RoundingTypeCode === 1) {
        roundingTemp = PayableTotal % this.currentBranch.RoundingAmount;
        this.invoice.RoundingAmount = this.currentBranch.RoundingAmount - roundingTemp;
      }
      //رو به پایین
      else if (this.currentBranch.RoundingTypeCode === 2) {
        roundingTemp = PayableTotal % this.currentBranch.RoundingAmount;
        this.invoice.RoundingAmount = roundingTemp * -1;
      }
    }
    if (this.currentSaleMethodNature !== this.SaleMethodNature.Delivery) {
      this.invoice.ShippingCost = 0;
      this.invoice.ShippingCostTax = 0;
    }

    // قابل پرداخت
    this.invoice.RoundingAmount = !this.currentBranch.HasAuditorInSalesAmounts
      ? Math.round(this.invoice.RoundingAmount)
      : parseFloat(this.invoice.RoundingAmount?.toFixed(4));
    this.invoice.RoundingAmount = !this.currentBranch.HasAuditorInSalesAmounts
      ? Math.round(this.invoice.RoundingAmount)
      : parseFloat(this.invoice.RoundingAmount?.toFixed(4));
    this.invoice.PayableTotal = PayableTotal + this.invoice.RoundingAmount;
    this.invoice.PayableTotal = !this.currentBranch.HasAuditorInSalesAmounts
      ? Math.round(this.invoice.PayableTotal)
      : parseFloat(this.invoice.PayableTotal?.toFixed(4));
    this.invoice.PayableTotal = !this.currentBranch.HasAuditorInSalesAmounts
      ? Math.round(this.invoice.PayableTotal)
      : parseFloat(this.invoice.PayableTotal?.toFixed(4));
    ///  کرایه مشتری
    if (this.invoice?.CustomerAddress?.ShippingCost && isNewCalculate && this.invoice.PayableTotal > 0) {
      this.setValue("ShippingCost", this.invoice.CustomerAddress ? this.invoice.CustomerAddress.ShippingCost : null);
    }

    // اعمال محاسبات نرخ خدمات سرویس سفارشات
    if (this.currentInformation?.OrderServices && this.saleMethodBranch.HasDeposit) {
      this.invoice.PayableTotal = this.invoice.PayableTotal + this.depositFormGroup.controls["ServicesAmount"].value;
      this.invoice.PayableTotal = !this.currentBranch.HasAuditorInSalesAmounts
        ? Math.round(this.invoice.PayableTotal)
        : parseFloat(this.invoice.PayableTotal?.toFixed(4));
      this.invoice.PayableTotal = !this.currentBranch.HasAuditorInSalesAmounts
        ? Math.round(this.invoice.PayableTotal)
        : parseFloat(this.invoice.PayableTotal?.toFixed(4));
      if (this.depositFormGroup.controls["NumberOfPeople"].value) {
        const result = this.invoice?.PayableTotal / this.depositFormGroup.controls["NumberOfPeople"].value;
        this.depositFormGroup.controls["FoodPricePerson"]?.setValue(result);
      }
    }

    // چک کردن بیزینس های مربوط به بدهکاری مشتری
    if (this.currentSaleMethodNature === this.SaleMethodNature.Delivery) {
      if (this.invoice?.Customer?.AutomaticDebtor && !this.invoice.isDebitDisable && (this.invoice.State == RowState.New || !this.invoice.State)) {
        this.invoice.Debit = this.invoice.PayableTotal;
        this.setValue("Debit", this.invoice.PayableTotal);
        this.invoice.isDebit = true;
      }
      if (this.invoice.Debit > this.invoice.PayableTotal) {
        this.invoice.Debit = this.invoice.PayableTotal;
        this.setValue("Debit", this.invoice.PayableTotal);
      }

      var calculateMoreOneTime: boolean = false;
      //مقایسه جمع کالاها با حداقل کرایه رایگان مشترک
      if (
        this.invoice?.CustomerAddress?.Zone?.MinimumPurchaseForFreeShipping > 0 &&
        (!this.formGroup.controls["Discount"].value || this.freeShippingCostDiscount === this.invoice.TotalDiscount) &&
        this.shouldCalculateFreeShippingCost &&
        !this.invoice.WebId // not delino
      ) {
        if (this.invoice?.CustomerAddress?.Zone?.MinimumPurchaseForFreeShipping <= this.invoice.Total && !this.freeShippingCostDiscount) {
          this.invoice.TotalDiscount += this.invoice.ShippingCost;
          this.invoice.Discount += this.invoice.ShippingCost;
          this.freeShippingCostDiscount = this.invoice.ShippingCost;
        } else if (
          this.invoice?.CustomerAddress?.Zone?.MinimumPurchaseForFreeShipping > this.invoice.Total &&
          this.freeShippingCostDiscount === this.invoice.TotalDiscount
        ) {
          this.invoice.TotalDiscount = 0;
          this.invoice.Discount = 0;
          this.freeShippingCostDiscount = 0;
        }
        this.invoice.IsDiscountPercent = false;
        this.setValue("TotalDiscount", this.invoice.TotalDiscount);
        this.setValue("Discount", this.invoice.Discount);
      }
    }
    if (this.invoice?.Id && this.invoice?.Debit > 0 && !this.invoice.Customer?.HasCredit) {
      this.invoice.Debit = 0;
    }
    this.invoice.Total = 0;
    this.invoice.Items.forEach((s) => {
      if (s.State != RowState.Delete) {
        this.invoice.Total += s.UnitPrice * s.Quantity + s.UnitAdditive * s.Quantity;
        this.invoice.Total = !this.currentBranch.HasAuditorInSalesAmounts
          ? Math.round(this.invoice.Total)
          : parseFloat(this.invoice.Total?.toFixed(4));
        this.invoice.Total = !this.currentBranch.HasAuditorInSalesAmounts
          ? Math.round(this.invoice.Total)
          : parseFloat(this.invoice.Total?.toFixed(4));
      }
    });

    if (this.clubcount == 1) this.ClubCalculate();
    this.clubcount = 1;
    this.actionState.save = false;
    this.actionState.cancel = false;
    this.actionState.clear = false;
    this.actionState.clearWithoutPrint = false;
    this.actionState.mixClear = false;
    this.actionState.print = false;
    this.actionState.preparationPrint = false;
    this.actionState.temporaryRegister = false;
    this.actionState.customerPrint = false;
    this.checkInvoiceState(this.invoice.CommandCode);

    this.minutesToDelivery();
    this.detectChanges();
    if (calculateMoreOneTime) {
      this.calculate();
    }
  }

  minutesToDelivery() {
    if (!this.invoice?.Customer) return;
    if (this.invoice.Customer.MinutesToDelivery || this.invoice?.Items?.length > 0) {
      var maxTimeCookingmodel: InvoiceItem;
      if (this.invoice?.Items?.length > 0) {
        maxTimeCookingmodel = this.invoice.Items?.reduce(function (prev, current) {
          return prev.CookingTime > current.CookingTime ? prev : current;
        });
      }
      this.invoice.Customer.MinutesToDelivery =
        (this.defaultMinutesToDelivery > 0 ? this.defaultMinutesToDelivery : 0) +
        (maxTimeCookingmodel?.CookingTime > 0 ? maxTimeCookingmodel?.CookingTime : 0);
    }
  }
  ClubCalculate() {
    if (!this.invoice.ClubViewModel) {
      return;
    }
    if (this.invoice.ClubViewModel) {
      this.invoice.ClubViewModel.ClubTotalDiscount = 0;
      this.invoice.ClubViewModel.DiscountPrice = 0;
      if (this.invoice.PayableTotal && this.invoice.ClubViewModel.UseCreditPrice > 0) {
        const ClubDiscount = this.getClubDiscountPrice();
        if (this.invoice.ClubViewModel.AvailableCredit + (ClubDiscount ? ClubDiscount : 0) > this.invoice.PayableTotal + this.invoice.TotalDiscount) {
          const diff = this.invoice.PayableTotalLessDiscount - (ClubDiscount ? ClubDiscount : 0);
          if (this.invoice.ClubViewModel.isDisableusedCredit) {
            this.invoice.ClubViewModel.UseCreditPrice = ClubDiscount + this.invoice.ClubViewModel.usedCredit;
          } else {
            this.invoice.ClubViewModel.UseCreditPrice = ClubDiscount + diff;
            this.invoice.ClubViewModel.usedCredit = diff;
          }
        } else {
          if (this.invoice.ClubViewModel.isDisableusedCredit) {
            this.invoice.ClubViewModel.UseCreditPrice = ClubDiscount + this.invoice.ClubViewModel.usedCredit;
          } else {
            this.invoice.ClubViewModel.UseCreditPrice = ClubDiscount + this.invoice.ClubViewModel.AvailableCredit;
            this.invoice.ClubViewModel.usedCredit = this.invoice.ClubViewModel.AvailableCredit;
          }
        }
        /// ccc تخٝیٝ کلی در صورت وجود باشگاه
        if (this.invoice?.HasClub) {
          const discount = this.invoice?.ClubViewModel?.UseCreditPrice ? this.invoice?.ClubViewModel?.UseCreditPrice : 0;
          this.invoice.IsDiscountPercent = false;
          this.invoice.DiscountPrice = discount;
          this.invoice.Discount = discount;
          this.setValue("Discount", discount);
        }
      }

      this.invoice.ClubViewModel.DiscountPrice = this.getClubDiscountPrice();

      this.invoice.ClubViewModel.CreditPrice = 0;
      if (this.invoice.ClubViewModel.AvailableCredit && this.invoice.ClubViewModel.AvailableCredit > 0) {
        if (this.invoice.TotalWidthRowDiscount < this.invoice.ClubViewModel.AvailableCredit) {
          this.invoice.ClubViewModel.CreditPrice = this.invoice.TotalWidthRowDiscount;
        } else {
          this.invoice.ClubViewModel.CreditPrice = this.invoice.ClubViewModel.AvailableCredit;
        }
      }
    }

    this.clubcount = 2;
    this.calculate();
  }

  getClubDiscountPrice(): number {
    let discountPrice = 0;
    /// زمانی که تخفیف درصدی فعال باشد
    /// مقایسه برای حداقل قیمت برای اعمال تخفیف درصدی
    if (
      this.invoice.ClubViewModel.DiscountPercent &&
      this.invoice.ClubViewModel.DiscountPercent !== 0 &&
      this.invoice.TotalWidthRowDiscount >= this.invoice.ClubViewModel.MinFactorPriceToActiveDiscountPercent
    ) {
      discountPrice = (this.invoice.TotalWidthRowDiscount * this.invoice.ClubViewModel.DiscountPercent) / 100;
      /// حداکثر ظرٝیت قابل استٝاده برای تخٝیٝ درصدی
      if (
        this.invoice.ClubViewModel.MaxUsablePriceFromDiscountPercent &&
        this.invoice.ClubViewModel.MaxUsablePriceFromDiscountPercent !== 0 &&
        discountPrice >= this.invoice.ClubViewModel.MaxUsablePriceFromDiscountPercent
      )
        discountPrice = this.invoice.ClubViewModel.MaxUsablePriceFromDiscountPercent;
    }

    return discountPrice;
  }

  calcDepositServiceAmount(rows: any[], amount = 0) {
    const sum = rows.length ? rows.map((x) => x.Amount).reduce((x, z) => Number(x) + Number(z)) : 0;
    this.depositServiceAmount = sum + amount;
    this.depositServiceRemain = this.depositFormGroup.controls["ServicesAmount"].value - this.depositServiceAmount;
    this.depositServiceRemainSummary = `${this.translate("ClientApp.FrontOffice.Order.Remainder")} : ${this.depositServiceRemain}`;
    this.depositServiceAmountSummary = `${this.translate("ClientApp.FrontOffice.Order.AmountOfService")} : ${this.depositServiceAmount}`;
  }

  depositValidation(): { errMessage: string; focusOnServicesAmount: boolean } {
    const depositControls = this.depositFormGroup.controls;
    let errMessage = "";
    let focusOnServicesAmount = false;
    const FormSetting = this.storage.getData(ClearableCache.FormSetting);
    if (!FormSetting?.HasClearType) this.depositFormGroup.controls["ClearType"].setErrors(null);
    if (!FormSetting?.HasDeliveryType) this.depositFormGroup.controls["DeliveryType"].setErrors(null);
    if (this.depositFormGroup.valid) {
      if (this.depositPersonnelList.length && !depositControls["ServicesAmount"].value) {
        focusOnServicesAmount = true;
        errMessage = this.translate("ClientApp.FrontOffice.Order.EnterServiceAmount");
        depositControls["ServicesAmount"].updateValueAndValidity();
      } else if (
        this.depositPersonnelList.length &&
        depositControls["ServicesAmount"].value &&
        this.depositServiceAmount !== depositControls["ServicesAmount"].value
      ) {
        errMessage = this.translate("ClientApp.FrontOffice.Order.EnterServiceAmountInFull");
      }
    } else {
      errMessage = this.translate("ClientApp.FrontOffice.Order.EnterNecessaryInformationServiceOrders");
      this.isShowDeposit = true;
      this.detectChanges();
    }

    return { errMessage, focusOnServicesAmount };
  }

  closeSidebar() {
    this._opened = false;
  }
  filterItembyBranchId(BranchId: number) {
    if (!this.itemCategoryListAll) return;
    this.itemCategoryList = JSON.parse(JSON.stringify(this.itemCategoryListAll));
    if (!BranchId || (this.currentBranch?.AccessToAllBranches && this.currentBranch?.BranchId === BranchId)) {
      this.itemCategoryList.forEach((element) => {
        element.Items = [];
      });
      this.selectedItemCategory.Items = [];
      this.detectChanges();
      return;
    }
    this.itemCategoryList?.forEach((ele, index) => {
      ele.Items.forEach((it) => {
        if (it.Branches?.length) {
          it.StockInWeb = it?.Branches?.find((f) => f.BranchId === BranchId)?.StockInWeb;
          let favItem = this.favoriteItems.find((item) => it.Id == item.ItemId && item.SaleMethodBranchId == this.saleMethodBranch.Id);
          favItem ? (it.favoriteIndex = favItem.index) : (it.favoriteIndex = -1);
          const usedGoodsInItem = this.warehouseStockItems?.filter(
            (f) => (f.PrevRemainAmount || f.EntryAmount) && f.BranchId === BranchId && f.ItemsInRelation.some((x) => x.Id === it.Id)
          );
          it.notAvailableGoodIds = usedGoodsInItem.filter((x) => x.Amount <= 0).map((x) => x.GoodsId);
        } else {
          it.StockInWeb = StockInWebKind.UnAvailable;
          it.ItemChild?.forEach((child) => {
            child.StockInWeb = child.Branches?.find((f) => f.BranchId === BranchId)?.StockInWeb;
            const usedGoodsInItem = this.warehouseStockItems?.filter(
              (f) => (f.PrevRemainAmount || f.EntryAmount) && f.BranchId === BranchId && f.ItemsInRelation.some((x) => x.Id === child.Id)
            );
            child.notAvailableGoodIds = usedGoodsInItem.filter((x) => x.Amount <= 0).map((x) => x.GoodsId);
          });
        }
      });
      if (ele.Id == 0) {
        let temp = this.sortingArrayByFav(ele.Items);
        ele.Items = temp;
      }

      if (index !== 0) {
        const state = this.getCategoryPopUpState(ele.Items);
        ele.categoryPopupState = state;
      }

      ele.Items = ele.Items.filter((f) => f.Branches === null || (f.Branches && f.Branches.some((s) => s.BranchId === BranchId && s.IsActive)));
      ele.Items = ele.Items.filter(
        (f) => (f.DataDaysWeekTitle && f.DataDaysWeekTitle?.includes(this.lastInvoiceInformation.DayOfWeek)) || !f.DataDaysWeekTitle
      );

      const findChild = ele.Items.filter((f) => f.ItemChild && f.ItemChild.length > 0);
      if (findChild && findChild.length > 0) {
        findChild.forEach((element) => {
          element.favoriteIndex = -1;
          element.ItemChild = element.ItemChild.filter((f) => f.Branches && f.Branches.some((s) => s.BranchId === BranchId));
          element.ItemChild = element.ItemChild.filter(
            (f) => (f.DataDaysWeekTitle && f.DataDaysWeekTitle?.includes(this.lastInvoiceInformation.DayOfWeek)) || !f.DataDaysWeekTitle
          );
          element.ItemChild.forEach((it) => {
            let favItem = this.favoriteItems.find((item) => it.Id == item.ItemId && item.SaleMethodBranchId == this.saleMethodBranch.Id); //&&
            if (favItem) {
              it.favoriteIndex = favItem.index;
              if (ele.Id == 0) {
                ele.Items.unshift(it);
                this.itemCategoryListAll[0].Items.unshift(it);
              }
            } else it.favoriteIndex = -1;
          });
          if (ele.Id == 0) {
            let temp = this.sortingArrayByFav(element.ItemChild);
            element.ItemChild = temp;
          }
        });
      }
    });
    // const favoritedItemsInBundles = this.getFavItemsOutOfBundle();

    this.itemCategoryList[0].Items = this.sortingArrayByFav(this.itemCategoryList[0].Items);
    this.itemCategoryListAll[0].Items = this.sortingArrayByFav(this.itemCategoryListAll[0].Items);
    this.getItemCategory();
  }
  private getCategoryPopUpState(items: OrderItem[], callSelfMethod = true) {
    const hasAnyBundle = items?.some((x) => x.Branches === null);
    let bundleStates = null;
    if (hasAnyBundle && callSelfMethod) {
      let bundleItems = items?.filter((x) => x.Branches === null).map((x) => x.ItemChild);
      const flatArray = bundleItems.reduce((acc, val) => acc.concat(val), []);
      bundleStates = this.getCategoryPopUpState(flatArray, false);
    }

    const anyItemsUnAvailable = items?.some((child) => child?.StockInWeb !== StockInWebKind.Available);
    const anyItemsAvailable = items?.some((child) => child?.StockInWeb === StockInWebKind.Available);
    let categoryPopupState = bundleStates;

    if (anyItemsUnAvailable) {
      if (anyItemsAvailable) {
        categoryPopupState = CategoryPopupState.Multi;
      } else if (bundleStates == null || bundleStates == CategoryPopupState.AllNonAvailable) {
        categoryPopupState = CategoryPopupState.AllNonAvailable;
      } else if (bundleStates == CategoryPopupState.AllAvailable || bundleStates == CategoryPopupState.Multi) {
        categoryPopupState = CategoryPopupState.Multi;
      }
    } else if (bundleStates == null || bundleStates == CategoryPopupState.AllAvailable) categoryPopupState = CategoryPopupState.AllAvailable;
    else categoryPopupState = CategoryPopupState.Multi;

    return categoryPopupState;
  }

  private updateItemNotAvailableGoodIds(BranchId: number, item: OrderItem, eventName: string) {
    const itemBranch = item.Branches.find((x) => x.BranchId === BranchId);
    if (
      item.notAvailableGoodIds?.length &&
      itemBranch &&
      (itemBranch.StockInWeb === StockInWebKind.Available || itemBranch.StockInWeb === StockInWebKind.UnAvailableOnSite)
    ) {
      itemBranch.StockInWeb = StockInWebKind.UnAvailableFromInv;
      item.StockInWeb = StockInWebKind.UnAvailableFromInv;
    } else if (
      !item.notAvailableGoodIds?.length &&
      itemBranch &&
      itemBranch.StockInWeb !== StockInWebKind.Available &&
      this.warehouseStockItems.some((w) => w.ItemsInRelation.some((x) => item.Id == x.Id)) &&
      (eventName !== "invoiceChanges" || itemBranch.StockInWeb !== StockInWebKind.UnAvailable)
    ) {
      itemBranch.StockInWeb = StockInWebKind.Available;
      item.StockInWeb = StockInWebKind.Available;
    }
  }

  updateStockInWebByInvSignal(branchId: number, warehouseStockItems: InvDailyWarehouse[], eventName: string) {
    this.itemCategoryList.forEach((ele) => {
      ele.Items.forEach((it) => {
        if (it.Branches?.length) {
          const usedGoodsInItem = warehouseStockItems?.filter(
            (f) => (f.PrevRemainAmount || f.EntryAmount) && f.BranchId === branchId && f.ItemsInRelation.some((x) => x.Id === it.Id)
          );
          it.notAvailableGoodIds = usedGoodsInItem.filter((x) => x.Amount <= 0).map((x) => x.GoodsId);
          if (usedGoodsInItem.length) this.updateItemNotAvailableGoodIds(branchId, it, eventName);
        } else {
          it.ItemChild?.forEach((child) => {
            const usedGoodsInItem = warehouseStockItems?.filter(
              (f) => (f.PrevRemainAmount || f.EntryAmount) && f.BranchId === branchId && f.ItemsInRelation.some((x) => x.Id === it.Id)
            );
            it.notAvailableGoodIds = usedGoodsInItem.filter((x) => x.Amount <= 0).map((x) => x.GoodsId);
            if (usedGoodsInItem.length) this.updateItemNotAvailableGoodIds(branchId, child, eventName);
          });
        }
      });
    });
    this.itemCategoryListAll = this.itemCategoryList;
    this.indexedDbService.put("FrontOffice", "Categories", this.itemCategoryListAll).then();
    this.itemCategoryList = JSON.parse(JSON.stringify(this.itemCategoryList));
    this.itemHasParent = null;
    this.getItemCategory();
    this.SalePriceChange(this.invoice.SalePriceTypeId, true);
  }

  // لود کردن تب جاری بر اساس ماهیت فروش
  public setActivePage(ActivePage?: ActivePageEnum) {
    if (!this.saleMethodBranch.Id) {
      this.detectChanges();
      return;
    }
    if (ActivePage) {
      this.currentActivePage = ActivePage;
      if (this.invoice.StatusCode === InvoiceStatus.New) {
        this.customerHasOpenInvoice();
      }
      this.detectChanges();
      return;
    }
    if (this.shouldActivateSalonPage) {
      if (this.saleMethodBranch.TableIsRequired) {
        this.currentActivePage = ActivePageEnum.Salon;
      } else if (this.common.isMobileMode) {
        this.currentActivePage = ActivePageEnum.OrderItem;
      } else this.currentActivePage = ActivePageEnum.Order;
      this.detectChanges();
      return;
    }
    if (this.shouldActivateInvoicesPage) {
      this.currentActivePage = ActivePageEnum.Invoices;
      this.detectChanges();
      return;
    }
    if (this.shouldActivateReserveOnlinePage) {
      this.currentActivePage = ActivePageEnum.ReserveOnline;
      this.detectChanges();
      return;
    }
    switch (this.currentSaleMethodNature) {
      case SaleMethodNature.Restaurant:
        if (this.saleMethodBranch.TableIsRequired) {
          this.currentActivePage = ActivePageEnum.Salon;
        } else {
          if (this.common.isMobileMode) this.currentActivePage = ActivePageEnum.OrderItem;
          else this.currentActivePage = ActivePageEnum.Order;
        }
        break;
      case SaleMethodNature.Delivery:
        this.currentActivePage = ActivePageEnum.Customer;
        break;
      case SaleMethodNature.FastFood:
        if (this.common.isMobileMode) {
          this.itemHasParent = null;
          this.currentActivePage = ActivePageEnum.OrderItem;
        } else this.currentActivePage = ActivePageEnum.Order;
        break;
    }
    if (this.invoice.StatusCode === InvoiceStatus.New) {
      this.customerHasOpenInvoice();
    }
    this.detectChanges();
  }
  /// چک کردن فاکتور باز برای مشتری و چک کردن کرایه
  customerHasOpenInvoice() {
    if (
      this.saleMethodBranch.SaleMethodNatureCode !== SaleMethodNature.Delivery ||
      this.currentActivePage !== ActivePageEnum.Order ||
      this.invoice.Customer?.Id === this.defaultCustomerId
    )
      return;
    else {
      this.httpCommonService
        .getItem(`Invoice/CustomerHasOpenInvoice`, this.invoice.CustomerId)
        .pipe(take(1))
        .subscribe((res: boolean) => {
          if (res) {
            this.sts.showDialog(
              this.translate("ClientApp.FrontOffice.Order.CustomerHasOpenInvoice"),
              this.translate("ClientApp.FrontOffice.Order.Warning"),
              DialogType.confirm,
              () => {
                if (this.invoice.ShippingCost === this.invoice.Discount) {
                  this.invoice.Discount = 0;
                  this.formGroup.controls["Discount"].setValue(0);
                }
                this.invoice.ShippingCost = 0;
                this.invoice.CourierShippingCost = 0;
                this.formGroup.controls["ShippingCost"].setValue(0);
                this.calculate();
                return;
              }
            );
          } else {
            return;
          }
        });
      return;
    }
  }
  focus(id: string) {
    const input: HTMLInputElement = document.getElementById(id) as HTMLInputElement;
    if (input) {
      input.focus();
      input.select();
    }
  }
  public focusInput() {
    if (this.saleMethodBranch.HasKeyboardOrder) {
      setTimeout(() => {
        this.focus(`Code${this.__id}`);
      }, 50);
    }
  }

  public customerInActiveCategory(addressId: number, currentCustomer: CustomerDetailInfoViewModel, branchId?: number): boolean {
    const CustomerAddress = currentCustomer?.Addresses.find((x) => x.Id === addressId);
    let defaultBranchId = branchId ? branchId : this.logInBranch.Id;
    if (!!this.isMultiBranch && !branchId) {
      defaultBranchId = CustomerAddress?.DefaultBranchId
        ? CustomerAddress?.DefaultBranchId
        : CustomerAddress?.Zone?.Branches?.find((f) => f.IsDefault)?.BranchId;
    }
    const saleMethodBranch = this.saleMethodList.find((f) => f.BranchId == defaultBranchId && f.SaleMethodId === this.saleMethodBranch.SaleMethodId);
    const isActiveCategory: boolean = saleMethodBranch?.CustomerCategories.some((c) => c.CategoryId == currentCustomer?.CategoryId);
    return !!isActiveCategory;
  }

  detectChanges() {
    if (this.cd) this.cd.markForCheck();
    if (this.cd_Description) this.cd_Description.markForCheck();
    if (this.cd_DescCustomer) this.cd_DescCustomer.markForCheck();
    if (this.cd_DescKitchen) this.cd_DescKitchen.markForCheck();
    if (this.cd_FastAccess) this.cd_FastAccess.markForCheck();
    if (this.cd_Invoice) this.cd_Invoice.markForCheck();
    if (this.cd_Salons) this.cd_Salons.markForCheck();
    if (this.cd_Total) this.cd_Total.markForCheck();
    if (this.cd_Header) this.cd_Header.markForCheck();
    if (this.cd_FastAccessClub) this.cd_FastAccessClub.markForCheck();
    if (this.cd_FastAccessCustomer) this.cd_FastAccessCustomer.markForCheck();
    if (this.cd_FastAccessDriverAssignment) this.cd_FastAccessDriverAssignment.markForCheck();
    if (this.cd_FastAccessInvoiceChange) this.cd_FastAccessInvoiceChange.markForCheck();
    if (this.cd_FastAccessPager) this.cd_FastAccessPager.markForCheck();
    if (this.cd_FastAccessSalon) this.cd_FastAccessSalon.markForCheck();
    if (this.cd_FastAccessWaiter) this.cd_FastAccessWaiter.markForCheck();
    if (this.cd_Footer) this.cd_Footer.markForCheck();
    if (this.cd_Deposit) this.cd_Deposit.markForCheck();
  }
  /// فعال  شدن عملگر ها با توجه به چک کردن وضعبت فاکتور
  public checkInvoiceState(Action: InvoiceCommand) {
    if (this.invoice.Items.length <= 0 && this.invoice.StatusCode !== InvoiceStatus.Pending) {
      return false;
    }
    if (!this.invoice.StatusCode && this.invoice.StatusCode !== 0) {
      return false;
    }

    // چک کردن وضعیت های  مجاز در فروش  فست فودی
    if (
      (this.HasAccess("ClearWithoutPrintClearedStatus") || this.HasAccess("ClearClearedStatus")) &&
      this.currentSaleMethodNature === this.SaleMethodNature.FastFood &&
      this.invoice.StatusCode !== InvoiceStatus.Cancelled
    ) {
      //this.actionState.clearWithoutPrint = true;
      this.actionState.clear = true;
      this.actionState.mixClear = true;
    }
    switch (this.invoice.StatusCode) {
      case InvoiceStatus.New:
        this.actionState.cancel = false;
        /// ثبت موقت
        this.actionState.temporaryRegister = true;
        /// چاپ و آماده سازی
        this.actionState.preparationPrint = true;
        if (this.currentSaleMethodNature === this.SaleMethodNature.Delivery) {
          if (this.currentInformation?.OrderServices && this.saleMethodBranch.HasDeposit) {
            this.actionState.clearWithoutPrint = false;
            this.actionState.clear = false;
            this.actionState.mixClear = false;
            this.actionState.preparationPrint = false;
            this.actionState.save = true;
            this.actionState.delivered = true;
          }
          return (this.actionState.save = false);
        }

        if (this.currentSaleMethodNature === this.SaleMethodNature.Restaurant) {
          this.actionState.clear = false;
          this.actionState.print = false;
          this.actionState.clearWithoutPrint = false;
        }

        // چک کردن وضعیت های غیر مجاز در فروش فست فودی
        if (this.currentSaleMethodNature === this.SaleMethodNature.FastFood) {
          this.actionState.customerPrint = false;
          this.actionState.preparationPrint = false;
        }

        if (this.HasAccess("ClearWithoutPrint") && this.currentSaleMethodNature === this.SaleMethodNature.FastFood) {
          this.actionState.clearWithoutPrint = true;
        }
        break;
      case InvoiceStatus.Pending: //ثبت موقت
        /// ثبت موقت
        this.actionState.temporaryRegister = true;
        /// چاپ و آماده سازی
        this.actionState.preparationPrint = true;
        if (this.currentSaleMethodNature === this.SaleMethodNature.Delivery) {
          this.actionState.print = true;
          if (this.currentInformation?.OrderServices && this.saleMethodBranch.HasDeposit) {
            this.actionState.preparationPrint = false;
            this.actionState.delivered = true;
          }
        }
        if (this.HasAccess("ClearWithoutPrintPendingStatus") && this.currentSaleMethodNature === this.SaleMethodNature.Restaurant) {
          this.actionState.print = true;
          this.actionState.clearWithoutPrint = true;
        }
        if (this.HasAccess("ClearWithoutPrintPendingStatus")) this.actionState.clearWithoutPrint = true;
        if (this.HasAccess("ClearPendingStatus")) this.actionState.clear = true;

        if (this.currentSaleMethodNature === this.SaleMethodNature.FastFood) {
          this.actionState.preparationPrint = false;
        }
        break;
      case InvoiceStatus.Ordering:
        if (this.HasAccess("ClearOrderingStatus")) this.actionState.clear = true;
        if (this.HasAccess("ClearWithoutPrintOrderingStatus")) this.actionState.clearWithoutPrint = true;
        if (this.HasAccess("CancelOrderingStatus")) this.actionState.cancel = true;

        if (this.currentSaleMethodNature === this.SaleMethodNature.Delivery) {
          this.actionState.clear = false;
          this.actionState.clearWithoutPrint = false;
        }
        if (this.currentSaleMethodNature === this.SaleMethodNature.Delivery && (this.invoiceChanged || this.itemChanged)) {
          this.actionState.preparationPrint = true;
          this.actionState.save = true;
          if (this.currentInformation?.OrderServices && this.saleMethodBranch.HasDeposit) {
            this.actionState.preparationPrint = false;
            this.actionState.delivered = true;
          }
        }
        if (this.currentSaleMethodNature === this.SaleMethodNature.Restaurant && (this.invoiceChanged || this.itemChanged)) {
          this.actionState.mixClear = true;
          this.actionState.preparationPrint = true;
          this.actionState.save = true;
        }
        // برای ٝعال شدن پرینت مشتری در حالت موقت
        if (this.HasAccess("CustomerPrintOrderingStatus") && this.currentSaleMethodNature === this.SaleMethodNature.Restaurant) {
          this.actionState.customerPrint = true;
        }

        break;
      case InvoiceStatus.Clearing:
        if (this.HasAccess("SaveWithoutPrintClearingStatus") || this.HasAccess("ClearClearingStatus") || this.HasAccess("CancelClearingStatus")) {
          this.actionState.save = true;
          this.actionState.clear = true;
          this.actionState.cancel = true;
        }
        if (this.HasAccess("ClearWithoutPrintClearingStatus")) this.actionState.clearWithoutPrint = true;

        if (this.currentSaleMethodNature === this.SaleMethodNature.Restaurant) {
          this.actionState.mixClear = true;
        }
        if (this.HasAccess("CustomerPrintClearingStatus") && this.itemChanged) {
          this.actionState.customerPrint = true;
        }
        break;
      case InvoiceStatus.Cleared:
        if (this.HasAccess("ClearClearedStatus") || this.HasAccess("ClearWithoutPrintClearedStatus")) {
          this.actionState.clear = true;
          this.actionState.clearWithoutPrint = true;
        }
        if (this.HasAccess("CancelClearedStatus")) this.actionState.cancel = true;

        if (this.currentSaleMethodNature === this.SaleMethodNature.Restaurant) this.actionState.mixClear = true;
        break;
      case InvoiceStatus.Assigned:
        if (this.HasAccess("SaveWithoutPrintAssignedStatus")) {
          this.actionState.save = true;
        }
        if (this.HasAccess("CancelAssignedStatus")) this.actionState.cancel = true;
        break;
      case InvoiceStatus.Cancelled:
        break;
      case InvoiceStatus.Completed:
        break;
      default:
        break;
    }
    this.detectChanges();
    return false;
  }
  /// بیزینس های کال سنتر
  ChangeBranch(branchId: number, setDefaultPriceType = true): void {
    if (this.invoice.Id) this.invoiceChanged = true;
    this.invoice.BranchId = branchId;
    if (this.Branches.length) {
      this.currentBranch = this.Branches.find((f) => f.Id === branchId);
    }
    this.checkInvoiceState(this.invoice.CommandCode);
    this.getMaxInvoiceCode(branchId);
    this.changeListBySalemethodBranch(setDefaultPriceType);
    this.filterItembyBranchId(branchId);
    this.SalePriceChange(this.invoice.SalePriceTypeId, true);
    if (this.isMultiBranch) {
      this.changeControlsDependentOnSaleMethodBranchId();
    }
    if (!this.isLight && this.warehouseStockItems.length) {
      this.setDailyInventoryList(branchId);
      if (this.isMultiBranch) {
        this.itemHasParent = null;
      }
    }
    this.detectChanges();
  }

  public setDailyInventoryList(branchId: number) {
    this.dailyInventoryList = this.warehouseStockItems.filter(
      (x) => x.MinAmount > 0 && (x.EntryAmount > 0 || x.PrevRemainAmount) && x.Amount <= x.MinAmount && x.BranchId === branchId
    );
  }

  changeControlsDependentOnSaleMethodBranchId(): void {
    for (const key in this.formGroup.controls) {
      if (key.startsWith("CustomDescription")) this.formGroup.removeControl(key);
      this.setValue(`CustomDescription${this.invoice.SaleMethodBranchId}`, undefined, false, Validators.maxLength(200));
    }
  }

  public checkActivationOfInvoiceItem(): void {
    this.invoice.Items = this.invoice.Items.filter((x) => this.itemCategoryList[0]?.Items.some((i) => i.Id === x.ItemId));
  }

  public clearAllAdditivesAndDescriptions(): void {
    this.invoice.Items.forEach((item) => {
      item.Additives = [];
      item.Descriptions = [];
      item.Description = "";
    });
  }

  getStatusOfLinkPayment(paymentLinkState: number | null): number {
    if (paymentLinkState === null) {
      return -1000; //A Value that cannot be used
    }

    const numberStr = paymentLinkState.toString();
    const restOfDigitsStr = numberStr.substring(1, 3);
    return parseInt(restOfDigitsStr, 10);
  }

  setShippingCost(branchId: number): void {
    if (this.isMultiBranch && this.invoice.CustomerAddress?.Zone?.Branches?.length > 1 && !this.defaultBranch?.Suspend) {
      const zoneBranch = this.invoice.CustomerAddress.Zone.Branches.find((x) => x.BranchId === branchId);
      if (zoneBranch.ShippingCost && zoneBranch.ShippingCost !== this.invoice.ShippingCost) {
        this.sts.showDialog(
          this.translate("ClientApp.FrontOffice.Order.ChangeBranchFareChange"),
          this.translate("ClientApp.FrontOffice.Order.Warning"),
          DialogType.confirm,
          () => {
            this.setValue("ShippingCost", zoneBranch.ShippingCost);
            this.invoice.ShippingCost = zoneBranch.ShippingCost;
            this.setValue("CourierShippingCost", zoneBranch.CourierShippingCost);
            this.invoice.CourierShippingCost = zoneBranch.CourierShippingCost;
            this.calculate();
            return;
          }
        );
      }
    }
  }

  getSaleMethodType() {
    this.checkPermissions();
    this.salePriceTypesAll = this.storage.getData(ClearableCache.SalePriceType);
    this.salePriceType = this.storage.getData(ClearableCache.SalePriceType);
    if (this.changeCachEnum.some((f) => f === ChangeCachEnum.SalePriceType) && this.salePriceType != null) {
      this.salePriceType = this.salePriceType?.sort(function (a, b) {
        return a.Code - b.Code;
      });
      if (!this.invoice.Id) {
        const hasDefult = this.saleMethodBranch?.SalePriceTypes?.find((s) => s.IsDefault);
        if (hasDefult) this.invoice.SalePriceTypeId = hasDefult.SalePriceTypeId;
        else this.invoice.SalePriceTypeId = this.salePriceType[0].Id;
      }

      this.salePriceType = this.salePriceTypesAll.filter(
        (f) => !this.saleMethodBranch?.SalePriceTypes?.some((s) => s.SalePriceTypeId == f.Id && !s.IsDefault)
      );
      this.SalePriceChange(this.invoice.SalePriceTypeId, true);
      this.cd.markForCheck();
      this.setValue(`SalePriceTypeId`, this.invoice.SalePriceTypeId);
    } else {
      this.httpCommonService
        .getList("SalePriceType/ReadLookUp")
        .pipe(take(1))
        .subscribe((data: Lookup[]) => {
          this.storage.savePermanentData(data, ClearableCache.SalePriceType);
          this.salePriceType = data.sort(function (a, b) {
            return a.Code - b.Code;
          });
          this.salePriceTypesAll = Object.assign([], this.salePriceType);
          if (!this.invoice.Id) {
            const hasDefult = this.saleMethodBranch?.SalePriceTypes?.find((s) => s.IsDefault);
            if (hasDefult) this.invoice.SalePriceTypeId = hasDefult.SalePriceTypeId;
            else this.invoice.SalePriceTypeId = this.salePriceType[0].Id;
          }
          this.salePriceType = this.salePriceTypesAll?.filter(
            (f) => !this.saleMethodBranch?.SalePriceTypes?.some((s) => s.SalePriceTypeId == f.Id && !s.IsDefault)
          );
          this.SalePriceChange(this.invoice.SalePriceTypeId, true);
          this.setValue(`SalePriceTypeId`, this.invoice.SalePriceTypeId);
          this.storage.savePermanentData(this.salePriceType, ClearableCache.SalePriceType);
          this.detectChanges();
        });
    }
  }
  /// فیلتر بر اساس نحوه فروش
  changeListBySalemethodBranch(setDefaultPriceType: boolean) {
    if (!this.formGroup.controls["BranchId"]?.value) return;
    this.invoice.SaleMethodBranch = this.saleMethodList.find(
      (f) => f.BranchId == this.formGroup.controls["BranchId"]?.value && f.SaleMethodId === this.saleMethodBranch.SaleMethodId
    );
    this.SaleMethodBranchId = this.invoice.SaleMethodBranch?.Id;
    this.invoice.SaleMethodBranchId = this.SaleMethodBranchId;
    this.saleMethodBranch = this.invoice.SaleMethodBranch;
    /// Item Category
    const itemCategoryListIgnore = this.itemCategoryListAll?.filter((c) =>
      this.invoice?.SaleMethodBranch?.ItemCategories?.some((s) => !s.IsDefault && s.CategoryId != c.Id)
    );
    if (itemCategoryListIgnore?.length > 0) this.itemCategoryList = JSON.parse(JSON.stringify(itemCategoryListIgnore));
    else {
      this.itemCategoryList = Object.assign([], this.itemCategoryListAll);
    }
    this.itemCategoryList[0].Items = this.itemCategoryList[0]?.Items?.filter((c) => this.itemCategoryList?.some((s) => c.CategoryId == s.Id));
    let findDefaultItemCategory = this.saleMethodBranch?.ItemCategories.find((f) => f.IsDefault);
    if (findDefaultItemCategory)
      this.selectedItemCategory = Object.assign(
        {},
        this.itemCategoryList?.find((f) => f.Id === (findDefaultItemCategory.Category?.ParentId || findDefaultItemCategory.CategoryId))
      );
    else {
      this.selectedItemCategory = Object.assign({}, this.itemCategoryList[0]);
    }

    if (setDefaultPriceType) {
      this.salePriceType = this.salePriceType?.sort(function (a, b) {
        return a.Code - b.Code;
      });
      const hasDefult = this.saleMethodBranch?.SalePriceTypes?.find((s) => s.IsDefault);
      if (hasDefult) this.invoice.SalePriceTypeId = hasDefult.SalePriceTypeId;
      else this.invoice.SalePriceTypeId = this.salePriceType[0].Id;
    }

    this.salePriceType = this.salePriceTypesAll?.filter(
      (f) => !this.saleMethodBranch?.SalePriceTypes?.some((s) => s.SalePriceTypeId == f.Id && !s.IsDefault)
    );
    this.SalePriceChange(this.invoice.SalePriceTypeId, true);
    this.setValue(`SalePriceTypeId`, this.invoice.SalePriceTypeId);
    this.setApplySnapValue();
    if (this.currentSaleMethodNature === this.SaleMethodNature.FastFood) {
      this.setValue("InPerson", !!this.saleMethodBranch?.InPerson);
      this.invoice.InPerson = !!this.saleMethodBranch?.InPerson;
    }
  }

  setInvoiceHasFactorAndHasPaymentLink(): void {
    if (
      this.currentInformation?.PaymentPanelAVA &&
      this.common.smartConnection &&
      this.saleMethodBranch?.IsPaymentLink &&
      this.invoice?.PhoneNumber?.startsWith("09") &&
      !this.invoice.Customer.AutomaticDebtor
    ) {
      const isNewCustomer = !this.invoice.Customer ? true : new Date(this.invoice.Customer.CreatedDate).toDateString() === new Date().toDateString();
      const newCustomerCondition = isNewCustomer && this.saleMethodBranch.HasPaymentLinkForNewCustomer;
      const hasAutomaticChecked = isNewCustomer
        ? newCustomerCondition && !this.invoice?.Customer?.FailurePaymentLink
        : !!this.saleMethodBranch?.AutomaticLinks && !this.invoice?.Customer?.FailurePaymentLink;
      const isNotFastFood = this.currentSaleMethodNature !== this.SaleMethodNature.FastFood;
      this.invoice.HasPaymentLink = hasAutomaticChecked && this.saleMethodBranch?.HasPaymentLink && isNotFastFood;
      this.invoice.HasFactorLink = hasAutomaticChecked && this.saleMethodBranch?.HasFactorLink;
    }
  }

  private getItemCategory(): void {
    let findDefault;

    const ItemCategories = this?.saleMethodBranch?.ItemCategories;
    if (ItemCategories && ItemCategories?.length > 0) {
      this.itemCategoryList = this.itemCategoryList.filter((f) => !ItemCategories.some((s) => s.CategoryId === f.Id && !s.IsDefault));
      this.itemCategoryList[0].Items = this.itemCategoryList[0].Items.filter(
        (f) => !ItemCategories.some((s) => s.CategoryId === f.CategoryId && !s.IsDefault)
      );
      findDefault = this.saleMethodBranch?.ItemCategories?.find((f) => f.IsDefault);
    }
    if (this.selectedItemCategory.Id) {
      this.selectedItemCategory = Object.assign(
        {},
        this.itemCategoryList.find((f) => f.Id === this.selectedItemCategory.Id)
      );
    } else if (findDefault) {
      this.selectedItemCategory = Object.assign(
        {},
        this.itemCategoryList.find((f) => f.Id === (findDefault.Category?.ParentId || findDefault.CategoryId))
      );
    } else {
      this.selectedItemCategory = Object.assign({}, this.itemCategoryList[0]);
    }
    this.cd.markForCheck();
    this.detectChanges();
  }

  async checkOtherCustomerPrintAccess(printTemplateId: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.httpCommonService
        .getItem<boolean>("Invoice/CheckOtherCustomerPrintAccess", printTemplateId)
        .pipe(take(1))
        .subscribe(
          async (res: boolean) => {
            this.otherCustomerPrintAccess = res;
            resolve(res);
          },
          (err) => {
            reject(false);
          }
        );
      return this.otherCustomerPrintAccess;
    });
  }

  private setApplySnapValue(): void {
    if (typeof this.invoice.ApplySnap !== "boolean") {
      this.setValue("ApplySnap", this.saleMethodBranch?.HasSnap && this.saleMethodBranch?.AutoApplySnap);
      this.invoice.ApplySnap = this.saleMethodBranch?.HasSnap && this.saleMethodBranch?.AutoApplySnap;
    } else {
      this.setValue("ApplySnap", this.invoice.ApplySnap);
    }
  }
  /// Create method For Filter All Data By SaleMethodBranch
  FilterSaleMethodBranch(en: SaleMethodBranchItemEnum, list: any[]): any {
    switch (en) {
      case SaleMethodBranchItemEnum.ItemCategory:
        list = list.filter((f) => !this.saleMethodBranch?.ItemCategories?.some((s) => s.CategoryId == f.Id && !s.IsDefault));
        list.forEach((category) => {
          category.Items = category.Items.filter((f) => !this.saleMethodBranch?.ItemCategories?.some((s) => s.CategoryId == f.Id && !s.IsDefault));
        });
        let findDefaultItemCategory = this.saleMethodBranch.ItemCategories.find((f) => f.IsDefault);

        if (findDefaultItemCategory)
          this.selectedItemCategory = Object.assign(
            list.find((f) => f.Id === (findDefaultItemCategory.Category?.ParentId || findDefaultItemCategory.CategoryId))
          );
        // else {
        //this.selectedItemCategory = Object.assign([], list[0]);
        //}

        break;
    }
    return list;
  }
  // دریاٝت لیست کالایی
  GetItemCategoryList(isfirstGet = false) {
    this.indexedDbService.get("FrontOffice", "Categories").then(async (res) => {
      if (this.accountService.userHasPermission("RestaurantSale:FavoriteItem", "Get")) {
        this.canSeeFavorites = true;
        try {
          await this.getFavoriteItems();
        } catch (err) {
          console.log(err);
        }
      }
      this.itemCategoryListAll = res;

      if (this.changeCachEnum.some((f) => f === ChangeCachEnum.ItemcategoryList) && this.itemCategoryListAll?.length) {
        this.itemCategoryList = this.FilterSaleMethodBranch(SaleMethodBranchItemEnum.ItemCategory, this.itemCategoryListAll);
        this.filterItembyBranchId(!this.isMultiBranch ? this.logInBranch.Id : this.invoice.BranchId || null);

        this.fillDataAfterGetFirstData();
        this.getSaleMethodType();
        if (this.orderOnlinePage && isfirstGet) this.setActivePage(ActivePageEnum.OnlineFactor);

        this.detectChanges();
      } else {
        const computerName: string = this.storage.getData(ClearableCache.ComputerName);
        this.httpCommonService
          .get("ItemCategory/GetOrderItemCategory" + (computerName ? "?ComputerName=" + computerName : ""))
          .pipe(take(1))
          .subscribe(async (data: OrderItemCategory[]) => {
            await this.indexedDbService.put("FrontOffice", "Categories", data).then();
            // this.GetItemCategoryList(isfirstGet);
            this.itemCategoryListAll = data;
            this.itemCategoryList = this.FilterSaleMethodBranch(SaleMethodBranchItemEnum.ItemCategory, this.itemCategoryListAll);
            this.filterItembyBranchId(!this.isMultiBranch ? this.logInBranch.Id : this.invoice.BranchId || null);
            this.fillDataAfterGetFirstData();
            this.getSaleMethodType();
            if (this.orderOnlinePage && isfirstGet) this.setActivePage(ActivePageEnum.OnlineFactor);
            this.detectChanges();
          });
      }
    });
  }
  fillDataAfterGetFirstData() {
    this.hasForbiddenItems();
    this.currentBranch = this.logInBranch;
    this.invoice.SaleMethodBranchId = this.saleMethodBranch.Id;
  }
  hasForbiddenItems() {
    if (this.saleMethodBranch.Id || !this.invoice.Items || this.invoice.Items.length <= 0) return;
    this.invoice.Items.forEach((element) => {
      const find_item = this.itemCategoryList[0].Items.find((s) => s.Id === element.ItemId);
      if (!find_item)
        this.sts.showToast(
          "danger",
          this.translate("ClientApp.FrontOffice.Order.ErrorMessage"),
          this.translate("ClientApp.FrontOffice.Order.UnauthorizedItemInInvoice")
        );
      else {
        const find_itemchild = this.itemCategoryList[0].Items.find((s) => s.ItemChild !== null && s.ItemChild.length > 0);
        if (!find_itemchild && find_itemchild.Title !== element.ItemTitle) {
          this.sts.showToast(
            "danger",
            this.translate("ClientApp.FrontOffice.Order.ErrorMessage"),
            this.translate("ClientApp.FrontOffice.Order.UnauthorizedItemInInvoice")
          );
        }
      }
    });
  }

  private calculateDiscount(): void {
    this.happyHourDiscountValidation();
    if (this.validHappyHour && !this.validFreeShipping) {
      this.applyHappyHourDiscount();
    }
    if (this.validFreeShipping) {
      this.applyFreeShippingDiscount();
    }
    if (this.validFreeService && this.invoice.customerDiscountValue) {
      this.applyFreeServiceDiscount();
    }
  }

  applyCustomerDiscount(totalDiscountAmount: number, totalNumber: number) {
    const priceAfterDisount = totalNumber - totalDiscountAmount;
    const customerDiscountAmount = (priceAfterDisount * this.invoice.Customer.PercentDiscount) / 100;

    return totalDiscountAmount + customerDiscountAmount;
  }

  applyOrganizationDiscount() {
    this.invoice.DiscountType = DiscountTypeEnum.None;
    const remainedDiscountOfCustomer = this.invoice.Customer?.RemainedOrganizationDiscount;
    if (!remainedDiscountOfCustomer || remainedDiscountOfCustomer < 0) return;
    const remainedDays = this.invoice.Customer?.Category?.RemainingDays;
    if (remainedDays < 0 || !remainedDays) return;

    const organizationItems = this.invoice.Items.filter((it) => it.IsOrganizationalDiscount == true);
    if (!organizationItems.length) return;

    if (!this.invoice.Customer?.Category?.Quantity) return;

    let allOrganizationItemCount = 0;

    for (const item of organizationItems) {
      allOrganizationItemCount += item.Quantity;
    }

    const categoryDiscount = this.invoice.Customer?.Category.OrganizationalDiscount;
    if (allOrganizationItemCount > remainedDiscountOfCustomer) {
      let sum = 0;
      let invoiceTotalPrice = 0;
      for (const item of organizationItems) {
        let discount = 0;
        const totalPrice = item.Quantity * (item.UnitPrice + item.UnitAdditive);
        invoiceTotalPrice += totalPrice;
        discount = (totalPrice * (item.OrganizationalDiscount > 0 ? item.OrganizationalDiscount : categoryDiscount)) / 100;
        sum += discount;
        this.invoice.DiscountType = DiscountTypeEnum.Organization;
        const formControlName = `RowDiscount${item.Index}${this.invoice.SaleMethodBranchId}`;
        this.formGroup.controls[formControlName].disable();
      }
      sum = (sum / allOrganizationItemCount) * remainedDiscountOfCustomer;
      const nonOrganizationItems = this.invoice.Items.filter((it) => !it.IsOrganizationalDiscount);
      for (const item of nonOrganizationItems) {
        invoiceTotalPrice += item.Quantity * (item.UnitPrice + item.UnitAdditive);
      }
      if (this.invoice.Customer.PercentDiscount) {
        sum = this.applyCustomerDiscount(sum, invoiceTotalPrice);
      }
      this.invoice.Total = invoiceTotalPrice;
      this.DiscountOrganization = sum;
    } else {
      let totalPrice = 0;
      let totalDiscountPrice = 0;
      for (const item of organizationItems) {
        let discountPercent = item.OrganizationalDiscount ? item.OrganizationalDiscount : this.invoice.Customer.Category.OrganizationalDiscount;
        totalPrice += (item.UnitPrice + item.UnitAdditive) * item.Quantity;
        let discountPrice = (((item.UnitPrice + item.UnitAdditive) * discountPercent) / 100) * item.Quantity;
        this.invoice.DiscountType = DiscountTypeEnum.Organization;
        totalDiscountPrice += discountPrice;
        const formControlName = `RowDiscount${item.Index}${this.invoice.SaleMethodBranchId}`;
        this.formGroup.controls[formControlName].disable();
      }
      const nonOrganizationItems = this.invoice.Items.filter((it) => !it.IsOrganizationalDiscount);
      for (const item of nonOrganizationItems) {
        totalPrice += item.Quantity * (item.UnitPrice + item.UnitAdditive);
      }

      this.invoice.Total = totalPrice;
      this.DiscountOrganization = totalDiscountPrice;
    }

    this.invoice.IsDiscountPercent = false;
    this.invoice.Discount = this.DiscountOrganization;
    this.setValue("Discount", Math.round(this.DiscountOrganization));
  }

  applyFreeServiceDiscount() {
    let customerDiscountPrice = (this.invoice.Total * this.invoice.customerDiscountValue) / 100;
    if (this.saleMethodBranch.Discount) {
      if (!this.saleMethodBranch.IsDiscountPercent) {
        if (customerDiscountPrice < this.invoice.TotalService + this.saleMethodBranch.Discount) {
          this.invoice.IsDiscountPercent = false;
        } else {
          this.invoice.IsDiscountPercent = true;
          this.validFreeService = false;
          this.validHappyHour = false;
          this.invoice.Discount = this.invoice.customerDiscountValue;
          this.invoice.DiscountType = DiscountTypeEnum.Subscription;
        }
      } else {
        this.invoice.IsDiscountPercent = true;
        if (this.invoice.customerDiscountValue > this.invoice.ServiceRate + this.saleMethodBranch.Discount) {
          this.validFreeService = false;
          this.invoice.Discount = this.invoice.customerDiscountValue;
          this.validHappyHour = false;
          this.invoice.DiscountType = DiscountTypeEnum.Subscription;
        }
      }
    }
  }
  applyFreeShippingDiscount() {
    if (!this.invoice.customerDiscountValue) {
      this.invoice.Discount = this.invoice.ShippingCost;
      this.invoice.IsDiscountPercent = false;
      this.validHappyHour = true;
      this.invoice.DiscountType = DiscountTypeEnum.HappyHour;
    } else {
      this.invoice.DiscountPrice = (this.invoice.Total * this.invoice.customerDiscountValue) / 100;
      if (this.invoice.DiscountPrice < this.invoice.ShippingCost) {
        this.invoice.Discount = this.invoice.ShippingCost;
        this.invoice.IsDiscountPercent = false;
        this.validHappyHour = true;
        this.invoice.DiscountType = DiscountTypeEnum.HappyHour;
      } else {
        this.invoice.Discount = this.invoice.customerDiscountValue;
        this.invoice.IsDiscountPercent = true;
        this.validHappyHour = false;
        this.invoice.DiscountType = DiscountTypeEnum.Subscription;
      }
    }
  }
  applyHappyHourDiscount() {
    if (this.saleMethodBranch.IsDiscountPercent) {
      this.applyPercentDiscount();
    } else {
      this.applyFixedDiscount();
    }
  }

  applyFixedDiscount() {
    if (this.invoice.IsDiscountPercent) {
      this.invoice.DiscountPrice = (this.invoice.Total * this.invoice.Discount) / 100;
      this.invoice.DiscountPrice = !this.currentBranch.HasAuditorInSalesAmounts
        ? Math.round(this.invoice.DiscountPrice)
        : parseFloat(this.invoice.DiscountPrice.toFixed(4));
    }

    if (this.invoice.DiscountPrice <= this.saleMethodBranch.Discount + (this.validFreeService ? this.invoice.TotalService : 0)) {
      this.invoice.Discount = this.saleMethodBranch.Discount;
      this.validHappyHour = true;
      this.invoice.DiscountType = DiscountTypeEnum.HappyHour;
      this.invoice.IsDiscountPercent = false;
    } else {
      if (this.invoice.customerDiscountValue && this.validFreeService) {
        this.invoice.Discount = this.invoice.customerDiscountValue;
        this.validFreeService = false;
        this.validHappyHour = false;
        this.invoice.DiscountType = DiscountTypeEnum.Subscription;
        this.invoice.IsDiscountPercent = true;
      }
    }
  }
  applyPercentDiscount() {
    if (this.invoice.Discount <= this.saleMethodBranch.Discount + (this.validFreeService ? this.invoice.ServiceRate : 0)) {
      this.invoice.Discount = this.saleMethodBranch.Discount;
      this.invoice.DiscountType = DiscountTypeEnum.HappyHour;
      this.invoice.IsDiscountPercent = this.saleMethodBranch.IsDiscountPercent;
    } else {
      this.validHappyHour = false;
      this.validFreeService = false;
    }
  }

  setToDefaultPriceOrganization(items: InvoiceItem[]) {
    items.forEach((it) => {
      it.RowDiscountPrice = 0;
      it.RowDiscount = 0;
      const formControlName = `RowDiscount${it.Index}${this.invoice.SaleMethodBranchId}`;
      this.setValue(formControlName, it.RowDiscount);
      this.formGroup.controls[formControlName].enable();
    });
  }

  favoriteItems = [] as FavoriteItem[];
  async getFavoriteItems() {
    this.favoriteItems = await this.httpCommonService.getList<FavoriteItem[]>("FavoriteItem").toPromise();
  }

  async setFavorite(item: OrderItem) {
    let fav: FavoriteItem = {
      Id: undefined,
      ItemId: item.Id,
      SaleMethodBranchId: this.saleMethodBranch.Id,
      index: this.favoriteItems.length > 0 ? this.favoriteItems[this.favoriteItems.length - 1].index + 1 : 1,
    };
    const res = await this.httpCommonService.create("FavoriteItem", fav).toPromise<number>();
    if (typeof res == "number") {
      fav.Id = res;
      this.favoriteItems.push(fav);
      this.setIndexOnItems(fav, this.itemCategoryList);
      this.setIndexOnItems(fav, this.itemCategoryListAll);

      if (this.getItemInBundles(item.Id)) {
        this.itemCategoryList[0].Items.unshift(item);
        this.itemCategoryListAll[0].Items.unshift(item);
      }
      this.itemCategoryList[0].Items = this.sortingArrayByFav(this.itemCategoryList[0].Items);
      this.itemCategoryListAll[0].Items = this.sortingArrayByFav(this.itemCategoryListAll[0].Items);
      // await this.indexedDbService.put("FrontOffice", "Categories", this.itemCategoryListAll).then();
    }
  }
  async deleteFav(fav: FavoriteItem) {
    await this.httpCommonService.delete("FavoriteItem", fav.Id).toPromise();
    let indexInArray = this.favoriteItems.findIndex((it) => it.Id == fav.Id);
    this.favoriteItems.splice(indexInArray, 1);
    fav.index = -1;
    this.setIndexOnItems(fav, this.itemCategoryList);
    this.setIndexOnItems(fav, this.itemCategoryListAll);
    const itemInBundle = this.getItemInBundles(fav.ItemId);
    if (itemInBundle) {
      await this.deleteFromAllCategory(itemInBundle);
    }
    this.itemCategoryList[0].Items = this.sortingArrayByFav(this.itemCategoryList[0].Items);
    this.itemCategoryListAll[0].Items = this.sortingArrayByFav(this.itemCategoryListAll[0].Items);
    // await this.indexedDbService.put("FrontOffice", "Categories", this.itemCategoryListAll).then();
  }

  sortByFavs(items: OrderItem[]) {
    return items.sort((a, b) => a.favoriteIndex - b.favoriteIndex);
  }

  defaultSort(items: OrderItem[]) {
    return items.sort((a, b) => a.Code - b.Code);
  }

  sortingArrayByFav(items: OrderItem[]) {
    let favorites = items.filter((it) => it.favoriteIndex >= 0);
    let nonFavorites = items.filter((it) => !it.favoriteIndex || it.favoriteIndex == -1);
    let temp = [...items];
    if (nonFavorites && nonFavorites.length > 0) {
      if (favorites && favorites.length > 0) temp = [...this.sortByFavs(favorites), ...this.defaultSort(nonFavorites)];
      else temp = [...this.defaultSort(nonFavorites)];
    } else {
      if (favorites && favorites.length > 0) temp = [...this.sortByFavs(favorites)];
    }
    items = null;
    items = JSON.parse(JSON.stringify(temp));
    return temp;
  }

  setIndexOnItems(fav: FavoriteItem, items: OrderItemCategory[]) {
    let orderItem;
    for (let i = 0; i < items.length; i++) {
      let category = items[i];
      orderItem = category.Items.find((item) => item.Id == fav.ItemId && fav.SaleMethodBranchId == this.saleMethodBranch.Id);
      if (orderItem) {
        if (i == 0) {
          orderItem.favoriteIndex = fav.index;
        } else {
          orderItem.favoriteIndex = fav.index;
          break;
        }
      }
    }
    if (!orderItem) {
      for (let category of items) {
        let bundles = category.Items.filter((it) => it.ItemChild && it.ItemChild.length > 0);
        if (bundles && bundles.length > 0) {
          for (let bundle of bundles) {
            orderItem = bundle.ItemChild.find((child) => child.Id == fav.ItemId && fav.SaleMethodBranchId == this.saleMethodBranch.Id);
            if (orderItem) {
              // if (fav.index == -1) this.deleteFromAllCategory(orderItem);
              // else if (this.selectedItemCategory.Id == 0) this.itemCategoryList[0].Items.push(orderItem);
              orderItem.favoriteIndex = fav.index;
              break;
            }
          }
        }
      }
    }
  }

  async deleteFromAllCategory(item: OrderItem) {
    let index = this.itemCategoryList[0].Items.findIndex((it) => item.Id == it.Id);
    if (index !== -1) this.itemCategoryList[0].Items.splice(index, 1);
    let indexAll = this.itemCategoryListAll[0].Items.findIndex((it) => item.Id == it.Id);
    if (indexAll !== -1) this.itemCategoryListAll[0].Items.splice(index, 1);
  }

  // getFavItemsOutOfBundle() {
  //   let items = [];
  //   for (let bundle of this.getBundles()) {
  //     items.push(...bundle.ItemChild.filter((it) => it.favoriteIndex >= 0));
  //   }
  //   return items;
  // }

  getItemInBundles(searchItemId: number) {
    let item: OrderItem;
    for (let bundle of this.getBundles()) {
      item = bundle.ItemChild.find((it) => it.Id == searchItemId);
      if (item) {
        break;
      }
    }
    return item;
  }

  getBundles() {
    let category = this.itemCategoryList[0];
    const bundles = category.Items.filter((it) => it.ItemChild && it.ItemChild.length > 0);
    return bundles;
  }
}
